/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Fiddy API
 * Documentation interne — **nesso dev only**.

## Auth

Deux headers requis sur tous les endpoints protégés :
- `Authorization: Bearer <JWT>` — obtenu via `POST /auth` (expire après 30 min, refresh via `POST /auth/refresh`)
- `App-Id: <workspace_app_id>`

## Conventions

- Pagination : `data[]` + objet `pagination`
- Erreurs : schéma `HttpError` (`code` + `message`)
- Validation : `422` avec tableau `violations`

## Docs

- Accéder à [Swagger](/)
- Accéder à [Scalar](/scalar)

 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AdminBrandsParams,
  AdminChangelogs200,
  AdminChangelogsParams,
  AdminGetCollection200,
  AdminGetCollectionParams,
  AdminLocales200,
  AdminLocalesParams,
  AdminWorkspaceConfigs200,
  AdminWorkspaceConfigsParams,
  ApiAdmincompaniesGetCollection200,
  ApiAdmincompaniesGetCollectionParams,
  ApiAdminconfigsGetCollectionParams,
  ApiAdminemailsGetCollection200,
  ApiAdminemailsGetCollectionParams,
  ApiAdmininsightscompaniesGetCollectionParams,
  ApiAdmininsightsordersGetCollectionParams,
  ApiAdmininsightsperformancesGetCollectionParams,
  ApiAdmininsightspointsGetCollectionParams,
  ApiAdmininsightsusersGetCollectionParams,
  ApiAdminlogicTypeStepHistoriesGetCollection200,
  ApiAdminlogicTypeStepHistoriesGetCollectionParams,
  ApiAdminlogicsworkspacesGetCollectionParams,
  ApiAdminperformancesGetCollection200,
  ApiAdminperformancesGetCollectionParams,
  ApiAdminpointsGetCollection200,
  ApiAdminpointsGetCollectionParams,
  ApiAdminpurchaseProofsGetCollection200,
  ApiAdminpurchaseProofsGetCollectionParams,
  ApiAdminsalesHierarchyLinksIdDeleteParams,
  ApiAdminsegmentsGetCollection200,
  ApiAdminsegmentsGetCollectionParams,
  ApiAdminsegmentsIdmembersGetCollection200,
  ApiAdminsegmentsIdmembersGetCollectionParams,
  ApiAdmintargetsGetCollection200,
  ApiAdmintargetsGetCollectionParams,
  ApiAdmintypologiesGetCollection200,
  ApiAdmintypologiesGetCollectionParams,
  ApiAdminusersGetCollection200,
  ApiAdminusersGetCollectionParams,
  ApiAdminusersIdhistoryGetCollection200,
  ApiAdminusersIdhistoryGetCollectionParams,
  ApiAdminusersIdloginHistoryGetCollection200,
  ApiAdminusersIdloginHistoryGetCollectionParams,
  ApiAdminvideoNoticesGetCollection200,
  ApiAdminvideoNoticesGetCollectionParams,
  ApiAdminwaitingListsGetCollection200,
  ApiAdminwaitingListsGetCollectionParams,
  ApiBoostersGetCollectionParams,
  ApiChangelogsGetCollection200,
  ApiChangelogsGetCollectionParams,
  ApiCountriesGetCollection200,
  ApiCountriesGetCollectionParams,
  ApiGamesGetCollectionParams,
  ApiLocalesGetCollectionParams,
  ApiOrdersGetCollection200,
  ApiOrdersGetCollectionParams,
  ApiReferencesGetCollection200,
  ApiReferencesGetCollectionParams,
  ApiShopsGetCollection200,
  ApiShopsGetCollectionParams,
  ApiShopsShopIdbrandsGetCollectionParams,
  ApiShopsShopIdcategoriesGetCollectionParams,
  ApiShopsShopIdproductsGetCollection200,
  ApiShopsShopIdproductsGetCollectionParams,
  ApiTokenApiTokenReadModel,
  ApiTokenApiTokenWriteModel,
  AutoLoginRequestModel,
  BoosterBoosterCollectionReadModel,
  BoosterBoosterReadModel,
  BoosterBoosterWriteJsonMergePatchModel,
  BoosterBoosterWriteModel,
  CartHealthcheckCartHealthcheckReadModel,
  CartHealthcheckCartHealthcheckWriteModel,
  ChangelogChangelogReadModel,
  ChangelogChangelogWriteJsonMergePatchModel,
  ChangelogChangelogWriteModel,
  CompanyCompanyImportModel,
  CompanyCompanyReadModel,
  CompanyCompanyUpdateJsonMergePatchModel,
  CompanyResponsibleCompanyResponsibleReadModel,
  CompanyResponsibleCompanyResponsibleWriteModel,
  ConfigConfigReadModel,
  ConfigConfigWriteModel,
  ConstraintViolationJsonldModel,
  ConstraintViolationModel,
  CountryCountryReadModel,
  CountryCountryWriteModel,
  ErrorJsonldModel,
  ErrorModel,
  ForgotPasswordRequestV2Model,
  ForgotPasswordSubmitBodyModel,
  ForgotPasswordValidateV2Model,
  GameGameCollectionReadModel,
  GameGameReadModel,
  GameGameUpdateJsonMergePatchModel,
  GameGameWriteModel,
  GroupedLocalesModel,
  GroupedWorkspaceConfigModel,
  HelpRequestModel,
  ImportCompanyDtoCompanyImportModel,
  ImportLogicTypeTargetStatusDtoTargetsImportModel,
  ImportModel,
  ImportPerformanceDtoPerformanceImportModel,
  ImportPointDtoPointImportModel,
  ImportQueueModel,
  ImportReferenceDtoReferenceImportModel,
  ImportUserDtoUserImportModel,
  InsightCompanyInsightCompanyReadModel,
  InsightDashboardInsightDashboardReadModel,
  InsightOrderInsightOrderReadModel,
  InsightPerformanceInsightPerformanceReadModel,
  InsightPointInsightPointReadModel,
  InsightUserInsightUserMeReadModel,
  InsightUserInsightUserReadModel,
  JWTRefreshTokenModel,
  JWTTokenModel,
  LocaleCustomLocaleCustomEditJsonMergePatchModel,
  LocaleCustomLocaleCustomWriteModel,
  LocaleCustomModel,
  LocaleLocaleAdminReadModel,
  LocaleLocaleWriteJsonMergePatchModel,
  LocaleLocaleWriteModel,
  LogModel,
  LogicLogicReadModel,
  LogicLogicWriteModel,
  LogicTypeStepLogicTypeStepPatchJsonMergePatchModel,
  LogicTypeStepLogicTypeStepReadModel,
  LogicWorkspaceLogicWorkspaceReadModel,
  LogicWorkspaceLogicWorkspaceWriteModel,
  LoginCheckPostBody,
  MeInsightsParams,
  MediaMediaReadModel,
  MediaUploadModel,
  N400Response,
  N401Response,
  N403Response,
  N404Response,
  N422Response,
  OrderOrderReadModel,
  OrderOrderWriteModel,
  PasswordUpdateModel,
  PerformancePerformanceImportModel,
  PerformancePerformanceReadModel,
  PointPointImportModel,
  PointPointReadModel,
  ProductBrandProductBrandReadModel,
  ProductBrandProductBrandWriteJsonMergePatchModel,
  ProductBrandProductBrandWriteModel,
  ProductCategoryProductCategoryReadModel,
  ProductCategoryProductCategoryWriteJsonMergePatchModel,
  ProductCategoryProductCategoryWriteModel,
  ProductProductReadModel,
  ProductProductReadProductReadSensitiveModel,
  ProductProductStatusJsonMergePatchModel,
  ProductProductUpdateJsonMergePatchModel,
  ProductProductWriteModel,
  ProfileUpdateBody,
  PurchaseProofPurchaseProofReadModel,
  PurchaseProofPurchaseProofSubmitModel,
  PurchaseProofPurchaseProofWriteJsonMergePatchModel,
  RewardGroupedRewardGroupedRewardReadModel,
  RewardRewardPatchJsonMergePatchModel,
  RewardRewardReadModel,
  RewardRewardWriteModel,
  RouteRouteReadModel,
  RouteRouteWriteModel,
  SalesHierarchyLinkSalesHierarchyLinkReadModel,
  SalesHierarchyLinkSalesHierarchyLinkWriteModel,
  SalesHierarchySalesHierarchyLinkSalesHierarchyLinkTreeReadModel,
  SalesHierarchySalesHierarchyReadModel,
  SalesHierarchySalesHierarchyWriteJsonMergePatchModel,
  SalesHierarchySalesHierarchyWriteModel,
  ScheduledTaskScheduledTaskReadModel,
  SegmentCriterionSegmentCriterionReadModel,
  SegmentEntitySegmentEntityCollectionReadModel,
  SegmentEntitySegmentEntityReadModel,
  SegmentEntitySegmentEntityWriteModel,
  SegmentPreviewSegmentPreviewReadModel,
  SegmentPreviewSegmentPreviewWriteModel,
  SegmentSegmentReadModel,
  SegmentSegmentUpdateJsonMergePatchModel,
  SegmentSegmentWriteModel,
  ShopShopReadModel,
  ShopShopUpdateJsonMergePatchModel,
  ShopShopWriteModel,
  ShopWorkspaceShopWorkspaceReadModel,
  ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel,
  ShopWorkspaceShopWorkspaceWriteModel,
  SimpleJWTTokenModel,
  SwitchWorkspaceModel,
  TypologyTypologyReadModel,
  TypologyTypologyUpdateJsonMergePatchModel,
  TypologyTypologyWriteModel,
  UpdateCompanyDtoCompanyUpdateJsonMergePatchModel,
  UserMeReadModel,
  UserPurchaseProofs200,
  UserPurchaseProofsParams,
  UserScheduledTaskUserScheduledTaskReadModel,
  UserScheduledTaskUserScheduledTaskWriteModel,
  UserUserImportModel,
  UserUserReadModel,
  UserUserSendFirstConnexionModel,
  UserUserUpdateJsonMergePatchModel,
  ValidateWorkspaceConfigurationBody,
  VideoNoticeVideoNoticeReadModel,
  VideoNoticeVideoNoticeUpdateJsonMergePatchModel,
  VideoNoticeVideoNoticeWriteModel,
  WaitingListWaitingListReadModel,
  WaitingListWaitingListSubmitJsonMergePatchModel,
  WaitingListWaitingListWriteJsonMergePatchModel,
  WaitingListWaitingListWriteModel,
  WidgetItemConfigurationWidgetConfigReadModel,
  WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel,
  WidgetWidgetReadModel,
  WidgetWidgetWriteModel,
  WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel,
  WidgetWorkspaceWidgetWorkspaceReadModel,
  WidgetWorkspaceWidgetWorkspaceWriteModel,
  WorkspaceConfigWorkspaceConfigReadModel,
  WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel,
  WorkspaceConfigWorkspaceConfigWriteModel,
  WorkspaceConfigurationWorkspaceConfigurationReadModel,
  WorkspaceWorkspaceConfigWriteJsonMergePatchModel,
  WorkspaceWorkspaceInviteModel,
  WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel,
  WorkspaceWorkspaceReadAdminWorkspaceReadModel,
  WorkspaceWorkspaceReadModel,
  WorkspaceWorkspaceWriteModel
} from './client.schemas';

import { customInstance } from '../orval-axios-mutator';
import type { ErrorType , BodyType } from '../orval-axios-mutator';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Creates a user token.
 * @summary Login
 */
export const loginCheckPost = (
    loginCheckPostBody: BodyType<LoginCheckPostBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<JWTTokenModel>(
      {url: `/auth`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: loginCheckPostBody, signal
    },
      options);
    }
  


export const getLoginCheckPostMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: BodyType<LoginCheckPostBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: BodyType<LoginCheckPostBody>}, TContext> => {

const mutationKey = ['loginCheckPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof loginCheckPost>>, {data: BodyType<LoginCheckPostBody>}> = (props) => {
          const {data} = props ?? {};

          return  loginCheckPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LoginCheckPostMutationResult = NonNullable<Awaited<ReturnType<typeof loginCheckPost>>>
    export type LoginCheckPostMutationBody = BodyType<LoginCheckPostBody>
    export type LoginCheckPostMutationError = ErrorType<N400Response | N401Response | N403Response>

    /**
 * @summary Login
 */
export const useLoginCheckPost = <TError = ErrorType<N400Response | N401Response | N403Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof loginCheckPost>>, TError,{data: BodyType<LoginCheckPostBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof loginCheckPost>>,
        TError,
        {data: BodyType<LoginCheckPostBody>},
        TContext
      > => {

      const mutationOptions = getLoginCheckPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Extract token from magic link and provide token
 * @summary Autologin via magic link token
 */
export const postAuthAutologin = (
    autoLoginRequestModel: BodyType<AutoLoginRequestModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<JWTTokenModel>(
      {url: `/auth/autologin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: autoLoginRequestModel, signal
    },
      options);
    }
  


export const getPostAuthAutologinMutationOptions = <TError = ErrorType<N400Response | N401Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthAutologin>>, TError,{data: BodyType<AutoLoginRequestModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthAutologin>>, TError,{data: BodyType<AutoLoginRequestModel>}, TContext> => {

const mutationKey = ['postAuthAutologin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthAutologin>>, {data: BodyType<AutoLoginRequestModel>}> = (props) => {
          const {data} = props ?? {};

          return  postAuthAutologin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthAutologinMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthAutologin>>>
    export type PostAuthAutologinMutationBody = BodyType<AutoLoginRequestModel>
    export type PostAuthAutologinMutationError = ErrorType<N400Response | N401Response | N404Response>

    /**
 * @summary Autologin via magic link token
 */
export const usePostAuthAutologin = <TError = ErrorType<N400Response | N401Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthAutologin>>, TError,{data: BodyType<AutoLoginRequestModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthAutologin>>,
        TError,
        {data: BodyType<AutoLoginRequestModel>},
        TContext
      > => {

      const mutationOptions = getPostAuthAutologinMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Refresh token
 * @summary Refresh token
 */
export const postAuthRefresh = (
    jWTRefreshTokenModel: BodyType<JWTRefreshTokenModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<JWTTokenModel>(
      {url: `/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: jWTRefreshTokenModel, signal
    },
      options);
    }
  


export const getPostAuthRefreshMutationOptions = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: BodyType<JWTRefreshTokenModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: BodyType<JWTRefreshTokenModel>}, TContext> => {

const mutationKey = ['postAuthRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefresh>>, {data: BodyType<JWTRefreshTokenModel>}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefresh(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefresh>>>
    export type PostAuthRefreshMutationBody = BodyType<JWTRefreshTokenModel>
    export type PostAuthRefreshMutationError = ErrorType<N400Response | N401Response>

    /**
 * @summary Refresh token
 */
export const usePostAuthRefresh = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: BodyType<JWTRefreshTokenModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefresh>>,
        TError,
        {data: BodyType<JWTRefreshTokenModel>},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Add log to Sentry
 * @summary Add log to Sentry
 */
export const postLogs = (
    logModel: BodyType<LogModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/logs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logModel, signal
    },
      options);
    }
  


export const getPostLogsMutationOptions = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogs>>, TError,{data: BodyType<LogModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postLogs>>, TError,{data: BodyType<LogModel>}, TContext> => {

const mutationKey = ['postLogs'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postLogs>>, {data: BodyType<LogModel>}> = (props) => {
          const {data} = props ?? {};

          return  postLogs(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostLogsMutationResult = NonNullable<Awaited<ReturnType<typeof postLogs>>>
    export type PostLogsMutationBody = BodyType<LogModel>
    export type PostLogsMutationError = ErrorType<N400Response | N401Response>

    /**
 * @summary Add log to Sentry
 */
export const usePostLogs = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postLogs>>, TError,{data: BodyType<LogModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postLogs>>,
        TError,
        {data: BodyType<LogModel>},
        TContext
      > => {

      const mutationOptions = getPostLogsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Handle help request & send email
 * @summary Handle help request
 */
export const postHelp = (
    helpRequestModel: BodyType<HelpRequestModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/help`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: helpRequestModel, signal
    },
      options);
    }
  


export const getPostHelpMutationOptions = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelp>>, TError,{data: BodyType<HelpRequestModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postHelp>>, TError,{data: BodyType<HelpRequestModel>}, TContext> => {

const mutationKey = ['postHelp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHelp>>, {data: BodyType<HelpRequestModel>}> = (props) => {
          const {data} = props ?? {};

          return  postHelp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHelpMutationResult = NonNullable<Awaited<ReturnType<typeof postHelp>>>
    export type PostHelpMutationBody = BodyType<HelpRequestModel>
    export type PostHelpMutationError = ErrorType<N400Response | N401Response>

    /**
 * @summary Handle help request
 */
export const usePostHelp = <TError = ErrorType<N400Response | N401Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHelp>>, TError,{data: BodyType<HelpRequestModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postHelp>>,
        TError,
        {data: BodyType<HelpRequestModel>},
        TContext
      > => {

      const mutationOptions = getPostHelpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Ask for a password reset
 * @summary Ask for a password reset
 */
export const postForgotPassword = (
    forgotPasswordRequestV2Model: BodyType<ForgotPasswordRequestV2Model>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/auth/reset-password/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordRequestV2Model, signal
    },
      options);
    }
  


export const getPostForgotPasswordMutationOptions = <TError = ErrorType<N400Response | N403Response | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForgotPassword>>, TError,{data: BodyType<ForgotPasswordRequestV2Model>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postForgotPassword>>, TError,{data: BodyType<ForgotPasswordRequestV2Model>}, TContext> => {

const mutationKey = ['postForgotPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForgotPassword>>, {data: BodyType<ForgotPasswordRequestV2Model>}> = (props) => {
          const {data} = props ?? {};

          return  postForgotPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof postForgotPassword>>>
    export type PostForgotPasswordMutationBody = BodyType<ForgotPasswordRequestV2Model>
    export type PostForgotPasswordMutationError = ErrorType<N400Response | N403Response | void>

    /**
 * @summary Ask for a password reset
 */
export const usePostForgotPassword = <TError = ErrorType<N400Response | N403Response | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForgotPassword>>, TError,{data: BodyType<ForgotPasswordRequestV2Model>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postForgotPassword>>,
        TError,
        {data: BodyType<ForgotPasswordRequestV2Model>},
        TContext
      > => {

      const mutationOptions = getPostForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Validate token
 * @summary Validate token
 */
export const getForgotPassword = (
    tokenValue: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ForgotPasswordValidateV2Model>(
      {url: `/auth/reset-password/${encodeURIComponent(String(tokenValue))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetForgotPasswordQueryKey = (tokenValue?: string | undefined | null,) => {
    return [
    `/auth/reset-password/${tokenValue}`
    ] as const;
    }

    
export const getGetForgotPasswordQueryOptions = <TData = Awaited<ReturnType<typeof getForgotPassword>>, TError = ErrorType<N403Response | N404Response>>(tokenValue: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetForgotPasswordQueryKey(tokenValue);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getForgotPassword>>> = ({ signal }) => getForgotPassword(tokenValue, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(tokenValue), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetForgotPasswordQueryResult = NonNullable<Awaited<ReturnType<typeof getForgotPassword>>>
export type GetForgotPasswordQueryError = ErrorType<N403Response | N404Response>


export function useGetForgotPassword<TData = Awaited<ReturnType<typeof getForgotPassword>>, TError = ErrorType<N403Response | N404Response>>(
 tokenValue: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForgotPassword>>,
          TError,
          Awaited<ReturnType<typeof getForgotPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForgotPassword<TData = Awaited<ReturnType<typeof getForgotPassword>>, TError = ErrorType<N403Response | N404Response>>(
 tokenValue: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getForgotPassword>>,
          TError,
          Awaited<ReturnType<typeof getForgotPassword>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetForgotPassword<TData = Awaited<ReturnType<typeof getForgotPassword>>, TError = ErrorType<N403Response | N404Response>>(
 tokenValue: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Validate token
 */

export function useGetForgotPassword<TData = Awaited<ReturnType<typeof getForgotPassword>>, TError = ErrorType<N403Response | N404Response>>(
 tokenValue: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getForgotPassword>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetForgotPasswordQueryOptions(tokenValue,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Submit new password
 * @summary Submit new password
 */
export const postForgotPasswordToken = (
    tokenValue: string | undefined | null,
    forgotPasswordSubmitBodyModel: BodyType<ForgotPasswordSubmitBodyModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/auth/reset-password/${encodeURIComponent(String(tokenValue))}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordSubmitBodyModel, signal
    },
      options);
    }
  


export const getPostForgotPasswordTokenMutationOptions = <TError = ErrorType<N400Response | N403Response | N404Response | N422Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForgotPasswordToken>>, TError,{tokenValue: string | undefined | null;data: BodyType<ForgotPasswordSubmitBodyModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postForgotPasswordToken>>, TError,{tokenValue: string | undefined | null;data: BodyType<ForgotPasswordSubmitBodyModel>}, TContext> => {

const mutationKey = ['postForgotPasswordToken'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postForgotPasswordToken>>, {tokenValue: string | undefined | null;data: BodyType<ForgotPasswordSubmitBodyModel>}> = (props) => {
          const {tokenValue,data} = props ?? {};

          return  postForgotPasswordToken(tokenValue,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostForgotPasswordTokenMutationResult = NonNullable<Awaited<ReturnType<typeof postForgotPasswordToken>>>
    export type PostForgotPasswordTokenMutationBody = BodyType<ForgotPasswordSubmitBodyModel>
    export type PostForgotPasswordTokenMutationError = ErrorType<N400Response | N403Response | N404Response | N422Response>

    /**
 * @summary Submit new password
 */
export const usePostForgotPasswordToken = <TError = ErrorType<N400Response | N403Response | N404Response | N422Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postForgotPasswordToken>>, TError,{tokenValue: string | undefined | null;data: BodyType<ForgotPasswordSubmitBodyModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postForgotPasswordToken>>,
        TError,
        {tokenValue: string | undefined | null;data: BodyType<ForgotPasswordSubmitBodyModel>},
        TContext
      > => {

      const mutationOptions = getPostForgotPasswordTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get api public tokens of the current user
 * @summary Get api public tokens of the current user
 */
export const apiAdminapitokensGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiTokenApiTokenReadModel[]>(
      {url: `/admin/api/tokens`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminapitokensGetCollectionQueryKey = () => {
    return [
    `/admin/api/tokens`
    ] as const;
    }

    
export const getApiAdminapitokensGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminapitokensGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>> = ({ signal }) => apiAdminapitokensGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminapitokensGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>>
export type ApiAdminapitokensGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiAdminapitokensGetCollection<TData = Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminapitokensGetCollection<TData = Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminapitokensGetCollection<TData = Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get api public tokens of the current user
 */

export function useApiAdminapitokensGetCollection<TData = Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminapitokensGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminapitokensGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new api public token
 * @summary Create a new api public token
 */
export const apiAdminapitokensPost = (
    apiTokenApiTokenWriteModel: BodyType<ApiTokenApiTokenWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SimpleJWTTokenModel>(
      {url: `/admin/api/tokens`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: apiTokenApiTokenWriteModel, signal
    },
      options);
    }
  


export const getApiAdminapitokensPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensPost>>, TError,{data: BodyType<ApiTokenApiTokenWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensPost>>, TError,{data: BodyType<ApiTokenApiTokenWriteModel>}, TContext> => {

const mutationKey = ['apiAdminapitokensPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminapitokensPost>>, {data: BodyType<ApiTokenApiTokenWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminapitokensPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminapitokensPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminapitokensPost>>>
    export type ApiAdminapitokensPostMutationBody = BodyType<ApiTokenApiTokenWriteModel>
    export type ApiAdminapitokensPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new api public token
 */
export const useApiAdminapitokensPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensPost>>, TError,{data: BodyType<ApiTokenApiTokenWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminapitokensPost>>,
        TError,
        {data: BodyType<ApiTokenApiTokenWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminapitokensPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete an api public token
 * @summary Delete an api public token
 */
export const apiAdminapitokensIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/api/tokens/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminapitokensIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminapitokensIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminapitokensIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminapitokensIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>>
    
    export type ApiAdminapitokensIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Delete an api public token
 */
export const useApiAdminapitokensIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminapitokensIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminapitokensIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a booster on the current workspace
 * @summary Create a booster
 */
export const apiAdminboostersPost = (
    boosterBoosterWriteModel: BodyType<BoosterBoosterWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BoosterBoosterReadModel>(
      {url: `/admin/boosters`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: boosterBoosterWriteModel, signal
    },
      options);
    }
  


export const getApiAdminboostersPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersPost>>, TError,{data: BodyType<BoosterBoosterWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersPost>>, TError,{data: BodyType<BoosterBoosterWriteModel>}, TContext> => {

const mutationKey = ['apiAdminboostersPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminboostersPost>>, {data: BodyType<BoosterBoosterWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminboostersPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminboostersPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminboostersPost>>>
    export type ApiAdminboostersPostMutationBody = BodyType<BoosterBoosterWriteModel>
    export type ApiAdminboostersPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a booster
 */
export const useApiAdminboostersPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersPost>>, TError,{data: BodyType<BoosterBoosterWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminboostersPost>>,
        TError,
        {data: BodyType<BoosterBoosterWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminboostersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a booster. Only boosters that have not started yet can be deleted.
 * @summary Delete a booster
 */
export const apiAdminboostersIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/boosters/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminboostersIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response | N422Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminboostersIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminboostersIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminboostersIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminboostersIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminboostersIdDelete>>>
    
    export type ApiAdminboostersIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response | N422Response>

    /**
 * @summary Delete a booster
 */
export const useApiAdminboostersIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response | N422Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminboostersIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminboostersIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a booster
 * @summary Update a booster
 */
export const apiAdminboostersIdPatch = (
    id: string | undefined | null,
    boosterBoosterWriteJsonMergePatchModel: BodyType<BoosterBoosterWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<BoosterBoosterReadModel>(
      {url: `/admin/boosters/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: boosterBoosterWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminboostersIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<BoosterBoosterWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<BoosterBoosterWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminboostersIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminboostersIdPatch>>, {id: string | undefined | null;data: BodyType<BoosterBoosterWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminboostersIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminboostersIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminboostersIdPatch>>>
    export type ApiAdminboostersIdPatchMutationBody = BodyType<BoosterBoosterWriteJsonMergePatchModel>
    export type ApiAdminboostersIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a booster
 */
export const useApiAdminboostersIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminboostersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<BoosterBoosterWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminboostersIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<BoosterBoosterWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminboostersIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get boosters collection
 * @summary Get boosters collection
 */
export const apiBoostersGetCollection = (
    params?: ApiBoostersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BoosterBoosterCollectionReadModel[]>(
      {url: `/boosters`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiBoostersGetCollectionQueryKey = (params?: ApiBoostersGetCollectionParams,) => {
    return [
    `/boosters`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiBoostersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiBoostersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiBoostersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBoostersGetCollection>>> = ({ signal }) => apiBoostersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiBoostersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiBoostersGetCollection>>>
export type ApiBoostersGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiBoostersGetCollection<TData = Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiBoostersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiBoostersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiBoostersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiBoostersGetCollection<TData = Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiBoostersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiBoostersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiBoostersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiBoostersGetCollection<TData = Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiBoostersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get boosters collection
 */

export function useApiBoostersGetCollection<TData = Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiBoostersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiBoostersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a booster by ID
 * @summary Get a booster by ID
 */
export const apiBoostersIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BoosterBoosterReadModel>(
      {url: `/boosters/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiBoostersIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/boosters/${id}`
    ] as const;
    }

    
export const getApiBoostersIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiBoostersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiBoostersIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiBoostersIdGet>>> = ({ signal }) => apiBoostersIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiBoostersIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiBoostersIdGet>>>
export type ApiBoostersIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiBoostersIdGet<TData = Awaited<ReturnType<typeof apiBoostersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiBoostersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiBoostersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiBoostersIdGet<TData = Awaited<ReturnType<typeof apiBoostersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiBoostersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiBoostersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiBoostersIdGet<TData = Awaited<ReturnType<typeof apiBoostersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a booster by ID
 */

export function useApiBoostersIdGet<TData = Awaited<ReturnType<typeof apiBoostersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiBoostersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiBoostersIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Check the health of a cart
 * @summary Check the health of a cart
 */
export const apiCarthealthcheckPost = (
    cartHealthcheckCartHealthcheckWriteModel: BodyType<CartHealthcheckCartHealthcheckWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CartHealthcheckCartHealthcheckReadModel>(
      {url: `/cart/healthcheck`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cartHealthcheckCartHealthcheckWriteModel, signal
    },
      options);
    }
  


export const getApiCarthealthcheckPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCarthealthcheckPost>>, TError,{data: BodyType<CartHealthcheckCartHealthcheckWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCarthealthcheckPost>>, TError,{data: BodyType<CartHealthcheckCartHealthcheckWriteModel>}, TContext> => {

const mutationKey = ['apiCarthealthcheckPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCarthealthcheckPost>>, {data: BodyType<CartHealthcheckCartHealthcheckWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiCarthealthcheckPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCarthealthcheckPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiCarthealthcheckPost>>>
    export type ApiCarthealthcheckPostMutationBody = BodyType<CartHealthcheckCartHealthcheckWriteModel>
    export type ApiCarthealthcheckPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Check the health of a cart
 */
export const useApiCarthealthcheckPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCarthealthcheckPost>>, TError,{data: BodyType<CartHealthcheckCartHealthcheckWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiCarthealthcheckPost>>,
        TError,
        {data: BodyType<CartHealthcheckCartHealthcheckWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiCarthealthcheckPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Changelog resources.
 * @summary Retrieves the collection of Changelog resources.
 */
export const adminChangelogs = (
    params?: AdminChangelogsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminChangelogs200>(
      {url: `/admin/changelogs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminChangelogsQueryKey = (params?: AdminChangelogsParams,) => {
    return [
    `/admin/changelogs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminChangelogsQueryOptions = <TData = Awaited<ReturnType<typeof adminChangelogs>>, TError = ErrorType<N401Response | N403Response>>(params?: AdminChangelogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminChangelogsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminChangelogs>>> = ({ signal }) => adminChangelogs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminChangelogsQueryResult = NonNullable<Awaited<ReturnType<typeof adminChangelogs>>>
export type AdminChangelogsQueryError = ErrorType<N401Response | N403Response>


export function useAdminChangelogs<TData = Awaited<ReturnType<typeof adminChangelogs>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  AdminChangelogsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminChangelogs>>,
          TError,
          Awaited<ReturnType<typeof adminChangelogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminChangelogs<TData = Awaited<ReturnType<typeof adminChangelogs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminChangelogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminChangelogs>>,
          TError,
          Awaited<ReturnType<typeof adminChangelogs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminChangelogs<TData = Awaited<ReturnType<typeof adminChangelogs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminChangelogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Changelog resources.
 */

export function useAdminChangelogs<TData = Awaited<ReturnType<typeof adminChangelogs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminChangelogsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminChangelogs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminChangelogsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a Changelog resource.
 * @summary Creates a Changelog resource.
 */
export const apiAdminchangelogsPost = (
    changelogChangelogWriteModel: BodyType<ChangelogChangelogWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ChangelogChangelogReadModel>(
      {url: `/admin/changelogs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changelogChangelogWriteModel, signal
    },
      options);
    }
  


export const getApiAdminchangelogsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsPost>>, TError,{data: BodyType<ChangelogChangelogWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsPost>>, TError,{data: BodyType<ChangelogChangelogWriteModel>}, TContext> => {

const mutationKey = ['apiAdminchangelogsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminchangelogsPost>>, {data: BodyType<ChangelogChangelogWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminchangelogsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminchangelogsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminchangelogsPost>>>
    export type ApiAdminchangelogsPostMutationBody = BodyType<ChangelogChangelogWriteModel>
    export type ApiAdminchangelogsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a Changelog resource.
 */
export const useApiAdminchangelogsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsPost>>, TError,{data: BodyType<ChangelogChangelogWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminchangelogsPost>>,
        TError,
        {data: BodyType<ChangelogChangelogWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminchangelogsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes the Changelog resource.
 * @summary Removes the Changelog resource.
 */
export const apiAdminchangelogsIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/changelogs/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminchangelogsIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminchangelogsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminchangelogsIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminchangelogsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>>
    
    export type ApiAdminchangelogsIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Removes the Changelog resource.
 */
export const useApiAdminchangelogsIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminchangelogsIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminchangelogsIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the Changelog resource.
 * @summary Updates the Changelog resource.
 */
export const apiAdminchangelogsIdPatch = (
    id: string | undefined | null,
    changelogChangelogWriteJsonMergePatchModel: BodyType<ChangelogChangelogWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ChangelogChangelogReadModel>(
      {url: `/admin/changelogs/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: changelogChangelogWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminchangelogsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ChangelogChangelogWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ChangelogChangelogWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminchangelogsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>, {id: string | undefined | null;data: BodyType<ChangelogChangelogWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminchangelogsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminchangelogsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>>
    export type ApiAdminchangelogsIdPatchMutationBody = BodyType<ChangelogChangelogWriteJsonMergePatchModel>
    export type ApiAdminchangelogsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the Changelog resource.
 */
export const useApiAdminchangelogsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ChangelogChangelogWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminchangelogsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<ChangelogChangelogWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminchangelogsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Changelog resources.
 * @summary Retrieves the collection of Changelog resources.
 */
export const apiChangelogsGetCollection = (
    params?: ApiChangelogsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiChangelogsGetCollection200>(
      {url: `/changelogs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiChangelogsGetCollectionQueryKey = (params?: ApiChangelogsGetCollectionParams,) => {
    return [
    `/changelogs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiChangelogsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiChangelogsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiChangelogsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiChangelogsGetCollection>>> = ({ signal }) => apiChangelogsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiChangelogsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiChangelogsGetCollection>>>
export type ApiChangelogsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiChangelogsGetCollection<TData = Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiChangelogsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiChangelogsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiChangelogsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiChangelogsGetCollection<TData = Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiChangelogsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiChangelogsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiChangelogsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiChangelogsGetCollection<TData = Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiChangelogsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Changelog resources.
 */

export function useApiChangelogsGetCollection<TData = Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiChangelogsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiChangelogsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves a Changelog resource.
 * @summary Retrieves a Changelog resource.
 */
export const apiChangelogsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ChangelogChangelogReadModel>(
      {url: `/changelogs/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiChangelogsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/changelogs/${id}`
    ] as const;
    }

    
export const getApiChangelogsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiChangelogsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiChangelogsIdGet>>> = ({ signal }) => apiChangelogsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiChangelogsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiChangelogsIdGet>>>
export type ApiChangelogsIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiChangelogsIdGet<TData = Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiChangelogsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiChangelogsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiChangelogsIdGet<TData = Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiChangelogsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiChangelogsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiChangelogsIdGet<TData = Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Changelog resource.
 */

export function useApiChangelogsIdGet<TData = Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiChangelogsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiChangelogsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves the collection of Company resources.
 * @summary Retrieves the collection of Company resources.
 */
export const apiAdmincompaniesGetCollection = (
    params?: ApiAdmincompaniesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdmincompaniesGetCollection200>(
      {url: `/admin/companies`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmincompaniesGetCollectionQueryKey = (params?: ApiAdmincompaniesGetCollectionParams,) => {
    return [
    `/admin/companies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmincompaniesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdmincompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmincompaniesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>> = ({ signal }) => apiAdmincompaniesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmincompaniesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>>
export type ApiAdmincompaniesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdmincompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdmincompaniesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmincompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmincompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmincompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmincompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Company resources.
 */

export function useApiAdmincompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmincompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmincompaniesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add a new company
 * @summary Add a new company
 */
export const apiAdmincompaniesPost = (
    companyCompanyImportModel: BodyType<CompanyCompanyImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyCompanyReadModel>(
      {url: `/admin/companies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyCompanyImportModel, signal
    },
      options);
    }
  


export const getApiAdmincompaniesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesPost>>, TError,{data: BodyType<CompanyCompanyImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesPost>>, TError,{data: BodyType<CompanyCompanyImportModel>}, TContext> => {

const mutationKey = ['apiAdmincompaniesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmincompaniesPost>>, {data: BodyType<CompanyCompanyImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdmincompaniesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmincompaniesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesPost>>>
    export type ApiAdmincompaniesPostMutationBody = BodyType<CompanyCompanyImportModel>
    export type ApiAdmincompaniesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a new company
 */
export const useApiAdmincompaniesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesPost>>, TError,{data: BodyType<CompanyCompanyImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmincompaniesPost>>,
        TError,
        {data: BodyType<CompanyCompanyImportModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmincompaniesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import list of companies
 * @summary Import list of companies
 */
export const companiesImport = (
    importCompanyDtoCompanyImportModel: BodyType<ImportCompanyDtoCompanyImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportQueueModel | void>(
      {url: `/admin/companies/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importCompanyDtoCompanyImportModel, signal
    },
      options);
    }
  


export const getCompaniesImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesImport>>, TError,{data: BodyType<ImportCompanyDtoCompanyImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof companiesImport>>, TError,{data: BodyType<ImportCompanyDtoCompanyImportModel>}, TContext> => {

const mutationKey = ['companiesImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesImport>>, {data: BodyType<ImportCompanyDtoCompanyImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  companiesImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesImportMutationResult = NonNullable<Awaited<ReturnType<typeof companiesImport>>>
    export type CompaniesImportMutationBody = BodyType<ImportCompanyDtoCompanyImportModel>
    export type CompaniesImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import list of companies
 */
export const useCompaniesImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesImport>>, TError,{data: BodyType<ImportCompanyDtoCompanyImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof companiesImport>>,
        TError,
        {data: BodyType<ImportCompanyDtoCompanyImportModel>},
        TContext
      > => {

      const mutationOptions = getCompaniesImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update list of companies
 * @summary Update list of companies
 */
export const companiesBatchUpdate = (
    updateCompanyDtoCompanyUpdateJsonMergePatchModel: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ImportModel | void>(
      {url: `/admin/companies/update`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateCompanyDtoCompanyUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getCompaniesBatchUpdateMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesBatchUpdate>>, TError,{data: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof companiesBatchUpdate>>, TError,{data: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['companiesBatchUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companiesBatchUpdate>>, {data: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>}> = (props) => {
          const {data} = props ?? {};

          return  companiesBatchUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompaniesBatchUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companiesBatchUpdate>>>
    export type CompaniesBatchUpdateMutationBody = BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>
    export type CompaniesBatchUpdateMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update list of companies
 */
export const useCompaniesBatchUpdate = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companiesBatchUpdate>>, TError,{data: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof companiesBatchUpdate>>,
        TError,
        {data: BodyType<UpdateCompanyDtoCompanyUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getCompaniesBatchUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a Company resource.
 * @summary Retrieves a Company resource.
 */
export const apiAdmincompaniesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyCompanyReadModel>(
      {url: `/admin/companies/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdmincompaniesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/companies/${id}`
    ] as const;
    }

    
export const getApiAdmincompaniesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmincompaniesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>> = ({ signal }) => apiAdmincompaniesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmincompaniesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>>
export type ApiAdmincompaniesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmincompaniesIdGet<TData = Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmincompaniesIdGet<TData = Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmincompaniesIdGet<TData = Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Company resource.
 */

export function useApiAdmincompaniesIdGet<TData = Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmincompaniesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Soft-delete a company and all its users
 * @summary Soft-delete a company
 */
export const apiAdmincompaniesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/companies/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdmincompaniesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdmincompaniesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdmincompaniesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmincompaniesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>>
    
    export type ApiAdmincompaniesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Soft-delete a company
 */
export const useApiAdmincompaniesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmincompaniesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdmincompaniesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the Company resource.
 * @summary Updates the Company resource.
 */
export const apiCompaniesIdPatch = (
    id: string | undefined | null,
    companyCompanyUpdateJsonMergePatchModel: BodyType<CompanyCompanyUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CompanyCompanyReadModel>(
      {url: `/companies/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: companyCompanyUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiCompaniesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompaniesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<CompanyCompanyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiCompaniesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<CompanyCompanyUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiCompaniesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiCompaniesIdPatch>>, {id: string | undefined | null;data: BodyType<CompanyCompanyUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiCompaniesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiCompaniesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiCompaniesIdPatch>>>
    export type ApiCompaniesIdPatchMutationBody = BodyType<CompanyCompanyUpdateJsonMergePatchModel>
    export type ApiCompaniesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the Company resource.
 */
export const useApiCompaniesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiCompaniesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<CompanyCompanyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiCompaniesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<CompanyCompanyUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiCompaniesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Add a responsible to a company
 * @summary Add a responsible to a company
 */
export const apiAdmincompaniesCompanyIdresponsiblePost = (
    companyId: number | undefined | null,
    companyResponsibleCompanyResponsibleWriteModel: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CompanyResponsibleCompanyResponsibleReadModel>(
      {url: `/admin/companies/${encodeURIComponent(String(companyId))}/responsible`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyResponsibleCompanyResponsibleWriteModel, signal
    },
      options);
    }
  


export const getApiAdmincompaniesCompanyIdresponsiblePostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>, TError,{companyId: number | undefined | null;data: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>, TError,{companyId: number | undefined | null;data: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>}, TContext> => {

const mutationKey = ['apiAdmincompaniesCompanyIdresponsiblePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>, {companyId: number | undefined | null;data: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>}> = (props) => {
          const {companyId,data} = props ?? {};

          return  apiAdmincompaniesCompanyIdresponsiblePost(companyId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmincompaniesCompanyIdresponsiblePostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>>
    export type ApiAdmincompaniesCompanyIdresponsiblePostMutationBody = BodyType<CompanyResponsibleCompanyResponsibleWriteModel>
    export type ApiAdmincompaniesCompanyIdresponsiblePostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a responsible to a company
 */
export const useApiAdmincompaniesCompanyIdresponsiblePost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>, TError,{companyId: number | undefined | null;data: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsiblePost>>,
        TError,
        {companyId: number | undefined | null;data: BodyType<CompanyResponsibleCompanyResponsibleWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmincompaniesCompanyIdresponsiblePostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove a responsible from a company
 * @summary Remove a responsible from a company
 */
export const apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete = (
    companyId: number | undefined | null,
    responsibleId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/companies/${encodeURIComponent(String(companyId))}/responsible/${encodeURIComponent(String(responsibleId))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdmincompaniesCompanyIdresponsibleResponsibleIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>, TError,{companyId: number | undefined | null;responsibleId: number | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>, TError,{companyId: number | undefined | null;responsibleId: number | undefined | null}, TContext> => {

const mutationKey = ['apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>, {companyId: number | undefined | null;responsibleId: number | undefined | null}> = (props) => {
          const {companyId,responsibleId} = props ?? {};

          return  apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete(companyId,responsibleId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmincompaniesCompanyIdresponsibleResponsibleIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>>
    
    export type ApiAdmincompaniesCompanyIdresponsibleResponsibleIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Remove a responsible from a company
 */
export const useApiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>, TError,{companyId: number | undefined | null;responsibleId: number | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmincompaniesCompanyIdresponsibleResponsibleIdDelete>>,
        TError,
        {companyId: number | undefined | null;responsibleId: number | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdmincompaniesCompanyIdresponsibleResponsibleIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Config resources.
 * @summary Retrieves the collection of Config resources.
 */
export const apiAdminconfigsGetCollection = (
    params?: ApiAdminconfigsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigConfigReadModel[]>(
      {url: `/admin/configs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminconfigsGetCollectionQueryKey = (params?: ApiAdminconfigsGetCollectionParams,) => {
    return [
    `/admin/configs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminconfigsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminconfigsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminconfigsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>> = ({ signal }) => apiAdminconfigsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminconfigsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>>
export type ApiAdminconfigsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminconfigsGetCollection<TData = Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminconfigsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminconfigsGetCollection<TData = Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminconfigsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminconfigsGetCollection<TData = Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminconfigsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Config resources.
 */

export function useApiAdminconfigsGetCollection<TData = Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminconfigsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminconfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminconfigsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a Config resource.
 * @summary Creates a Config resource.
 */
export const apiAdminconfigsPost = (
    configConfigWriteModel: BodyType<ConfigConfigWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ConfigConfigReadModel>(
      {url: `/admin/configs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: configConfigWriteModel, signal
    },
      options);
    }
  


export const getApiAdminconfigsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminconfigsPost>>, TError,{data: BodyType<ConfigConfigWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminconfigsPost>>, TError,{data: BodyType<ConfigConfigWriteModel>}, TContext> => {

const mutationKey = ['apiAdminconfigsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminconfigsPost>>, {data: BodyType<ConfigConfigWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminconfigsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminconfigsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminconfigsPost>>>
    export type ApiAdminconfigsPostMutationBody = BodyType<ConfigConfigWriteModel>
    export type ApiAdminconfigsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a Config resource.
 */
export const useApiAdminconfigsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminconfigsPost>>, TError,{data: BodyType<ConfigConfigWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminconfigsPost>>,
        TError,
        {data: BodyType<ConfigConfigWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminconfigsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a Country resource.
 * @summary Creates a Country resource.
 */
export const apiAdmincountriesPost = (
    countryCountryWriteModel: BodyType<CountryCountryWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CountryCountryReadModel>(
      {url: `/admin/countries`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: countryCountryWriteModel, signal
    },
      options);
    }
  


export const getApiAdmincountriesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincountriesPost>>, TError,{data: BodyType<CountryCountryWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmincountriesPost>>, TError,{data: BodyType<CountryCountryWriteModel>}, TContext> => {

const mutationKey = ['apiAdmincountriesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmincountriesPost>>, {data: BodyType<CountryCountryWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdmincountriesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmincountriesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmincountriesPost>>>
    export type ApiAdmincountriesPostMutationBody = BodyType<CountryCountryWriteModel>
    export type ApiAdmincountriesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a Country resource.
 */
export const useApiAdmincountriesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmincountriesPost>>, TError,{data: BodyType<CountryCountryWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmincountriesPost>>,
        TError,
        {data: BodyType<CountryCountryWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmincountriesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Country resources.
 * @summary Retrieves the collection of Country resources.
 */
export const apiCountriesGetCollection = (
    params?: ApiCountriesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiCountriesGetCollection200>(
      {url: `/countries`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiCountriesGetCollectionQueryKey = (params?: ApiCountriesGetCollectionParams,) => {
    return [
    `/countries`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiCountriesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiCountriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiCountriesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountriesGetCollection>>> = ({ signal }) => apiCountriesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCountriesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiCountriesGetCollection>>>
export type ApiCountriesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiCountriesGetCollection<TData = Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiCountriesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCountriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiCountriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCountriesGetCollection<TData = Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiCountriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCountriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiCountriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCountriesGetCollection<TData = Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiCountriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Country resources.
 */

export function useApiCountriesGetCollection<TData = Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiCountriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiCountriesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves a Country resource.
 * @summary Retrieves a Country resource.
 */
export const apiCountriesAlpha3Get = (
    alpha3: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CountryCountryReadModel>(
      {url: `/countries/${encodeURIComponent(String(alpha3))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiCountriesAlpha3GetQueryKey = (alpha3?: string | undefined | null,) => {
    return [
    `/countries/${alpha3}`
    ] as const;
    }

    
export const getApiCountriesAlpha3GetQueryOptions = <TData = Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError = ErrorType<N401Response | N403Response | N404Response>>(alpha3: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiCountriesAlpha3GetQueryKey(alpha3);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>> = ({ signal }) => apiCountriesAlpha3Get(alpha3, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(alpha3), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiCountriesAlpha3GetQueryResult = NonNullable<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>>
export type ApiCountriesAlpha3GetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiCountriesAlpha3Get<TData = Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 alpha3: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCountriesAlpha3Get>>,
          TError,
          Awaited<ReturnType<typeof apiCountriesAlpha3Get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCountriesAlpha3Get<TData = Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 alpha3: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiCountriesAlpha3Get>>,
          TError,
          Awaited<ReturnType<typeof apiCountriesAlpha3Get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiCountriesAlpha3Get<TData = Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 alpha3: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Country resource.
 */

export function useApiCountriesAlpha3Get<TData = Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 alpha3: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiCountriesAlpha3Get>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiCountriesAlpha3GetQueryOptions(alpha3,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Paginated list of emails sent to users of the current workspace, sorted by sending date descending. Filterable by user workspace (userWorkspace.uniqueCode) or by company (userWorkspace.company.uniqueCode, userWorkspace.company.name), or by user fullname (user.fullname)
 * @summary Get emails sent to users of the current workspace
 */
export const apiAdminemailsGetCollection = (
    params?: ApiAdminemailsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminemailsGetCollection200>(
      {url: `/admin/emails`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminemailsGetCollectionQueryKey = (params?: ApiAdminemailsGetCollectionParams,) => {
    return [
    `/admin/emails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminemailsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminemailsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminemailsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>> = ({ signal }) => apiAdminemailsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminemailsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>>
export type ApiAdminemailsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminemailsGetCollection<TData = Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminemailsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminemailsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminemailsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminemailsGetCollection<TData = Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminemailsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminemailsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminemailsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminemailsGetCollection<TData = Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminemailsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get emails sent to users of the current workspace
 */

export function useApiAdminemailsGetCollection<TData = Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminemailsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminemailsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminemailsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add a new game
 * @summary Add a new game
 */
export const apiAdmingamesPost = (
    gameGameWriteModel: BodyType<GameGameWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameGameReadModel>(
      {url: `/admin/games`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: gameGameWriteModel, signal
    },
      options);
    }
  


export const getApiAdmingamesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesPost>>, TError,{data: BodyType<GameGameWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesPost>>, TError,{data: BodyType<GameGameWriteModel>}, TContext> => {

const mutationKey = ['apiAdmingamesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmingamesPost>>, {data: BodyType<GameGameWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdmingamesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmingamesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmingamesPost>>>
    export type ApiAdmingamesPostMutationBody = BodyType<GameGameWriteModel>
    export type ApiAdmingamesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a new game
 */
export const useApiAdmingamesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesPost>>, TError,{data: BodyType<GameGameWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmingamesPost>>,
        TError,
        {data: BodyType<GameGameWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmingamesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes the Game resource.
 * @summary Removes the Game resource.
 */
export const apiAdmingamesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/games/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdmingamesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdmingamesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmingamesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdmingamesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmingamesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmingamesIdDelete>>>
    
    export type ApiAdmingamesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Removes the Game resource.
 */
export const useApiAdmingamesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmingamesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdmingamesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the Game resource.
 * @summary Updates the Game resource.
 */
export const apiAdmingamesIdPatch = (
    id: string | undefined | null,
    gameGameUpdateJsonMergePatchModel: BodyType<GameGameUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GameGameReadModel>(
      {url: `/admin/games/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: gameGameUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdmingamesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<GameGameUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<GameGameUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdmingamesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmingamesIdPatch>>, {id: string | undefined | null;data: BodyType<GameGameUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdmingamesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmingamesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmingamesIdPatch>>>
    export type ApiAdmingamesIdPatchMutationBody = BodyType<GameGameUpdateJsonMergePatchModel>
    export type ApiAdmingamesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the Game resource.
 */
export const useApiAdmingamesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmingamesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<GameGameUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmingamesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<GameGameUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmingamesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Game resources.
 * @summary Retrieves the collection of Game resources.
 */
export const apiGamesGetCollection = (
    params?: ApiGamesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameGameCollectionReadModel[]>(
      {url: `/games`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiGamesGetCollectionQueryKey = (params?: ApiGamesGetCollectionParams,) => {
    return [
    `/games`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiGamesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiGamesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiGamesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiGamesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGamesGetCollection>>> = ({ signal }) => apiGamesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiGamesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiGamesGetCollection>>>
export type ApiGamesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiGamesGetCollection<TData = Awaited<ReturnType<typeof apiGamesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiGamesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiGamesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiGamesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiGamesGetCollection<TData = Awaited<ReturnType<typeof apiGamesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiGamesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiGamesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiGamesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiGamesGetCollection<TData = Awaited<ReturnType<typeof apiGamesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiGamesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Game resources.
 */

export function useApiGamesGetCollection<TData = Awaited<ReturnType<typeof apiGamesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiGamesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiGamesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves a Game resource.
 * @summary Retrieves a Game resource.
 */
export const apiGamesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GameGameReadModel>(
      {url: `/games/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiGamesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/games/${id}`
    ] as const;
    }

    
export const getApiGamesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiGamesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiGamesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGamesIdGet>>> = ({ signal }) => apiGamesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiGamesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiGamesIdGet>>>
export type ApiGamesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiGamesIdGet<TData = Awaited<ReturnType<typeof apiGamesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiGamesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiGamesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiGamesIdGet<TData = Awaited<ReturnType<typeof apiGamesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiGamesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiGamesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiGamesIdGet<TData = Awaited<ReturnType<typeof apiGamesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Game resource.
 */

export function useApiGamesIdGet<TData = Awaited<ReturnType<typeof apiGamesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiGamesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiGamesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get insights for all companies
 * @summary Get insights for all companies
 */
export const apiAdmininsightscompaniesGetCollection = (
    params?: ApiAdmininsightscompaniesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightCompanyInsightCompanyReadModel>(
      {url: `/admin/insights/companies`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmininsightscompaniesGetCollectionQueryKey = (params?: ApiAdmininsightscompaniesGetCollectionParams,) => {
    return [
    `/admin/insights/companies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmininsightscompaniesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: ApiAdmininsightscompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightscompaniesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>> = ({ signal }) => apiAdmininsightscompaniesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightscompaniesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>>
export type ApiAdmininsightscompaniesGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightscompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  ApiAdmininsightscompaniesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightscompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightscompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightscompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightscompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get insights for all companies
 */

export function useApiAdmininsightscompaniesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightscompaniesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightscompaniesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightscompaniesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get insights for active workspace
 * @summary Get insights for active workspace
 */
export const apiAdmininsightsdashboardGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightDashboardInsightDashboardReadModel>(
      {url: `/admin/insights/dashboard`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdmininsightsdashboardGetCollectionQueryKey = () => {
    return [
    `/admin/insights/dashboard`
    ] as const;
    }

    
export const getApiAdmininsightsdashboardGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightsdashboardGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>> = ({ signal }) => apiAdmininsightsdashboardGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightsdashboardGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>>
export type ApiAdmininsightsdashboardGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightsdashboardGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsdashboardGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsdashboardGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get insights for active workspace
 */

export function useApiAdmininsightsdashboardGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsdashboardGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightsdashboardGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get orders insights
 * @summary Get orders insights
 */
export const apiAdmininsightsordersGetCollection = (
    params?: ApiAdmininsightsordersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightOrderInsightOrderReadModel>(
      {url: `/admin/insights/orders`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmininsightsordersGetCollectionQueryKey = (params?: ApiAdmininsightsordersGetCollectionParams,) => {
    return [
    `/admin/insights/orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmininsightsordersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: ApiAdmininsightsordersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightsordersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>> = ({ signal }) => apiAdmininsightsordersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightsordersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>>
export type ApiAdmininsightsordersGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightsordersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  ApiAdmininsightsordersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsordersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsordersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsordersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsordersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get orders insights
 */

export function useApiAdmininsightsordersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsordersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsordersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightsordersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get performances insights
 * @summary Get performances insights
 */
export const apiAdmininsightsperformancesGetCollection = (
    params?: ApiAdmininsightsperformancesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightPerformanceInsightPerformanceReadModel>(
      {url: `/admin/insights/performances`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmininsightsperformancesGetCollectionQueryKey = (params?: ApiAdmininsightsperformancesGetCollectionParams,) => {
    return [
    `/admin/insights/performances`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmininsightsperformancesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: ApiAdmininsightsperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightsperformancesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>> = ({ signal }) => apiAdmininsightsperformancesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightsperformancesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>>
export type ApiAdmininsightsperformancesGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightsperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  ApiAdmininsightsperformancesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get performances insights
 */

export function useApiAdmininsightsperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightsperformancesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get points insights
 * @summary Get points insights
 */
export const apiAdmininsightspointsGetCollection = (
    params?: ApiAdmininsightspointsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightPointInsightPointReadModel>(
      {url: `/admin/insights/points`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmininsightspointsGetCollectionQueryKey = (params?: ApiAdmininsightspointsGetCollectionParams,) => {
    return [
    `/admin/insights/points`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmininsightspointsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: ApiAdmininsightspointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightspointsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>> = ({ signal }) => apiAdmininsightspointsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightspointsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>>
export type ApiAdmininsightspointsGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightspointsGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  ApiAdmininsightspointsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightspointsGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightspointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightspointsGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightspointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get points insights
 */

export function useApiAdmininsightspointsGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightspointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightspointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightspointsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get insights for all users
 * @summary Get insights for all users
 */
export const apiAdmininsightsusersGetCollection = (
    params?: ApiAdmininsightsusersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightUserInsightUserReadModel>(
      {url: `/admin/insights/users`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmininsightsusersGetCollectionQueryKey = (params?: ApiAdmininsightsusersGetCollectionParams,) => {
    return [
    `/admin/insights/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmininsightsusersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: ApiAdmininsightsusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmininsightsusersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>> = ({ signal }) => apiAdmininsightsusersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmininsightsusersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>>
export type ApiAdmininsightsusersGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmininsightsusersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  ApiAdmininsightsusersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsusersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmininsightsusersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get insights for all users
 */

export function useApiAdmininsightsusersGetCollection<TData = Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: ApiAdmininsightsusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmininsightsusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmininsightsusersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get insights for user logged
 * @summary Get insights for user logged
 */
export const meInsights = (
    params?: MeInsightsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<InsightUserInsightUserMeReadModel>(
      {url: `/users/insights/me`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getMeInsightsQueryKey = (params?: MeInsightsParams,) => {
    return [
    `/users/insights/me`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMeInsightsQueryOptions = <TData = Awaited<ReturnType<typeof meInsights>>, TError = ErrorType<N401Response | N403Response | N404Response>>(params?: MeInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeInsightsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meInsights>>> = ({ signal }) => meInsights(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeInsightsQueryResult = NonNullable<Awaited<ReturnType<typeof meInsights>>>
export type MeInsightsQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useMeInsights<TData = Awaited<ReturnType<typeof meInsights>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params: undefined |  MeInsightsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meInsights>>,
          TError,
          Awaited<ReturnType<typeof meInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeInsights<TData = Awaited<ReturnType<typeof meInsights>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: MeInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meInsights>>,
          TError,
          Awaited<ReturnType<typeof meInsights>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMeInsights<TData = Awaited<ReturnType<typeof meInsights>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: MeInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get insights for user logged
 */

export function useMeInsights<TData = Awaited<ReturnType<typeof meInsights>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 params?: MeInsightsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meInsights>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeInsightsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get of locales for workspace (non-formatted)
 * @summary Get list of locales for workspace (non-formatted)
 */
export const adminLocales = (
    params?: AdminLocalesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminLocales200>(
      {url: `/admin/locales`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminLocalesQueryKey = (params?: AdminLocalesParams,) => {
    return [
    `/admin/locales`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminLocalesQueryOptions = <TData = Awaited<ReturnType<typeof adminLocales>>, TError = ErrorType<N401Response | N403Response>>(params?: AdminLocalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminLocalesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminLocales>>> = ({ signal }) => adminLocales(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminLocalesQueryResult = NonNullable<Awaited<ReturnType<typeof adminLocales>>>
export type AdminLocalesQueryError = ErrorType<N401Response | N403Response>


export function useAdminLocales<TData = Awaited<ReturnType<typeof adminLocales>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  AdminLocalesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLocales>>,
          TError,
          Awaited<ReturnType<typeof adminLocales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLocales<TData = Awaited<ReturnType<typeof adminLocales>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminLocalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminLocales>>,
          TError,
          Awaited<ReturnType<typeof adminLocales>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminLocales<TData = Awaited<ReturnType<typeof adminLocales>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminLocalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get list of locales for workspace (non-formatted)
 */

export function useAdminLocales<TData = Awaited<ReturnType<typeof adminLocales>>, TError = ErrorType<N401Response | N403Response>>(
 params?: AdminLocalesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminLocales>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminLocalesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create new default locale
 * @summary Create new default locale
 */
export const apiAdminlocalesPost = (
    localeLocaleWriteModel: BodyType<LocaleLocaleWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocaleLocaleAdminReadModel>(
      {url: `/admin/locales`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: localeLocaleWriteModel, signal
    },
      options);
    }
  


export const getApiAdminlocalesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesPost>>, TError,{data: BodyType<LocaleLocaleWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesPost>>, TError,{data: BodyType<LocaleLocaleWriteModel>}, TContext> => {

const mutationKey = ['apiAdminlocalesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalesPost>>, {data: BodyType<LocaleLocaleWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminlocalesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalesPost>>>
    export type ApiAdminlocalesPostMutationBody = BodyType<LocaleLocaleWriteModel>
    export type ApiAdminlocalesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create new default locale
 */
export const useApiAdminlocalesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesPost>>, TError,{data: BodyType<LocaleLocaleWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalesPost>>,
        TError,
        {data: BodyType<LocaleLocaleWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete locale (and all locales custom associated to it)
 * @summary Delete locale (and all locales custom associated to it)
 */
export const apiAdminlocalesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/locales/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminlocalesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminlocalesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminlocalesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>>
    
    export type ApiAdminlocalesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Delete locale (and all locales custom associated to it)
 */
export const useApiAdminlocalesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update default locale
 * @summary Update default locale
 */
export const apiAdminlocalesIdPatch = (
    id: string | undefined | null,
    localeLocaleWriteJsonMergePatchModel: BodyType<LocaleLocaleWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LocaleLocaleAdminReadModel>(
      {url: `/admin/locales/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: localeLocaleWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminlocalesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleLocaleWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleLocaleWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminlocalesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>, {id: string | undefined | null;data: BodyType<LocaleLocaleWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminlocalesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>>
    export type ApiAdminlocalesIdPatchMutationBody = BodyType<LocaleLocaleWriteJsonMergePatchModel>
    export type ApiAdminlocalesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update default locale
 */
export const useApiAdminlocalesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleLocaleWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<LocaleLocaleWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get locales
 * @summary Get locales
 */
export const apiLocalesGetCollection = (
    params?: ApiLocalesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupedLocalesModel>(
      {url: `/locales`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiLocalesGetCollectionQueryKey = (params?: ApiLocalesGetCollectionParams,) => {
    return [
    `/locales`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiLocalesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError = ErrorType<N401Response>>(params?: ApiLocalesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiLocalesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiLocalesGetCollection>>> = ({ signal }) => apiLocalesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiLocalesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiLocalesGetCollection>>>
export type ApiLocalesGetCollectionQueryError = ErrorType<N401Response>


export function useApiLocalesGetCollection<TData = Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError = ErrorType<N401Response>>(
 params: undefined |  ApiLocalesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLocalesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiLocalesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLocalesGetCollection<TData = Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError = ErrorType<N401Response>>(
 params?: ApiLocalesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiLocalesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiLocalesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiLocalesGetCollection<TData = Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError = ErrorType<N401Response>>(
 params?: ApiLocalesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get locales
 */

export function useApiLocalesGetCollection<TData = Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError = ErrorType<N401Response>>(
 params?: ApiLocalesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiLocalesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiLocalesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a LocaleCustom resource.
 * @summary Creates a LocaleCustom resource.
 */
export const apiAdminlocalescustomPost = (
    localeCustomLocaleCustomWriteModel: BodyType<LocaleCustomLocaleCustomWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LocaleCustomModel>(
      {url: `/admin/locales/custom`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: localeCustomLocaleCustomWriteModel, signal
    },
      options);
    }
  


export const getApiAdminlocalescustomPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomPost>>, TError,{data: BodyType<LocaleCustomLocaleCustomWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomPost>>, TError,{data: BodyType<LocaleCustomLocaleCustomWriteModel>}, TContext> => {

const mutationKey = ['apiAdminlocalescustomPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalescustomPost>>, {data: BodyType<LocaleCustomLocaleCustomWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminlocalescustomPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalescustomPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalescustomPost>>>
    export type ApiAdminlocalescustomPostMutationBody = BodyType<LocaleCustomLocaleCustomWriteModel>
    export type ApiAdminlocalescustomPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a LocaleCustom resource.
 */
export const useApiAdminlocalescustomPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomPost>>, TError,{data: BodyType<LocaleCustomLocaleCustomWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalescustomPost>>,
        TError,
        {data: BodyType<LocaleCustomLocaleCustomWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalescustomPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes the LocaleCustom resource.
 * @summary Removes the LocaleCustom resource.
 */
export const apiAdminlocalescustomIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/locales/custom/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminlocalescustomIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminlocalescustomIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminlocalescustomIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalescustomIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>>
    
    export type ApiAdminlocalescustomIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Removes the LocaleCustom resource.
 */
export const useApiAdminlocalescustomIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalescustomIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalescustomIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the LocaleCustom resource.
 * @summary Updates the LocaleCustom resource.
 */
export const apiAdminlocalescustomIdPatch = (
    id: string | undefined | null,
    localeCustomLocaleCustomEditJsonMergePatchModel: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LocaleCustomModel>(
      {url: `/admin/locales/custom/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: localeCustomLocaleCustomEditJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminlocalescustomIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminlocalescustomIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>, {id: string | undefined | null;data: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminlocalescustomIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlocalescustomIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>>
    export type ApiAdminlocalescustomIdPatchMutationBody = BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>
    export type ApiAdminlocalescustomIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the LocaleCustom resource.
 */
export const useApiAdminlocalescustomIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlocalescustomIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<LocaleCustomLocaleCustomEditJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlocalescustomIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all logics
 * @summary Get all logics
 */
export const apiAdminlogicsGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogicLogicReadModel[]>(
      {url: `/admin/logics`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminlogicsGetCollectionQueryKey = () => {
    return [
    `/admin/logics`
    ] as const;
    }

    
export const getApiAdminlogicsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminlogicsGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>> = ({ signal }) => apiAdminlogicsGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminlogicsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>>
export type ApiAdminlogicsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminlogicsGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicsGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicsGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all logics
 */

export function useApiAdminlogicsGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminlogicsGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new logic
 * @summary Create a new logic
 */
export const apiAdminlogicsPost = (
    logicLogicWriteModel: BodyType<LogicLogicWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogicLogicReadModel>(
      {url: `/admin/logics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logicLogicWriteModel, signal
    },
      options);
    }
  


export const getApiAdminlogicsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsPost>>, TError,{data: BodyType<LogicLogicWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsPost>>, TError,{data: BodyType<LogicLogicWriteModel>}, TContext> => {

const mutationKey = ['apiAdminlogicsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlogicsPost>>, {data: BodyType<LogicLogicWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminlogicsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlogicsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicsPost>>>
    export type ApiAdminlogicsPostMutationBody = BodyType<LogicLogicWriteModel>
    export type ApiAdminlogicsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new logic
 */
export const useApiAdminlogicsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsPost>>, TError,{data: BodyType<LogicLogicWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlogicsPost>>,
        TError,
        {data: BodyType<LogicLogicWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlogicsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a LogicTypeStep resource.
 * @summary Retrieves a LogicTypeStep resource.
 */
export const apiAdminlogicTypeStepsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogicTypeStepLogicTypeStepReadModel>(
      {url: `/admin/logicTypeSteps/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminlogicTypeStepsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/logicTypeSteps/${id}`
    ] as const;
    }

    
export const getApiAdminlogicTypeStepsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminlogicTypeStepsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>> = ({ signal }) => apiAdminlogicTypeStepsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminlogicTypeStepsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>>
export type ApiAdminlogicTypeStepsIdGetQueryError = ErrorType<ErrorJsonldModel | ErrorModel>


export function useApiAdminlogicTypeStepsIdGet<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicTypeStepsIdGet<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicTypeStepsIdGet<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a LogicTypeStep resource.
 */

export function useApiAdminlogicTypeStepsIdGet<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminlogicTypeStepsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update the name and description of a step
 * @summary Update the name and description of a step
 */
export const apiAdminlogicTypeStepsIdPatch = (
    id: string | undefined | null,
    logicTypeStepLogicTypeStepPatchJsonMergePatchModel: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LogicTypeStepLogicTypeStepReadModel>(
      {url: `/admin/logicTypeSteps/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: logicTypeStepLogicTypeStepPatchJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminlogicTypeStepsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminlogicTypeStepsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>, {id: string | undefined | null;data: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminlogicTypeStepsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlogicTypeStepsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>>
    export type ApiAdminlogicTypeStepsIdPatchMutationBody = BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>
    export type ApiAdminlogicTypeStepsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update the name and description of a step
 */
export const useApiAdminlogicTypeStepsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlogicTypeStepsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<LogicTypeStepLogicTypeStepPatchJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlogicTypeStepsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all company steps (LogicTypeStepHistory) for the current workspace
 * @summary Get company steps
 */
export const apiAdminlogicTypeStepHistoriesGetCollection = (
    params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminlogicTypeStepHistoriesGetCollection200>(
      {url: `/admin/logicTypeStepHistories`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminlogicTypeStepHistoriesGetCollectionQueryKey = (params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams,) => {
    return [
    `/admin/logicTypeStepHistories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminlogicTypeStepHistoriesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminlogicTypeStepHistoriesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>> = ({ signal }) => apiAdminlogicTypeStepHistoriesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminlogicTypeStepHistoriesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>>
export type ApiAdminlogicTypeStepHistoriesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminlogicTypeStepHistoriesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminlogicTypeStepHistoriesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicTypeStepHistoriesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicTypeStepHistoriesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company steps
 */

export function useApiAdminlogicTypeStepHistoriesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicTypeStepHistoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicTypeStepHistoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminlogicTypeStepHistoriesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all company objectives (LogicTypeTargetStatus) for the current workspace
 * @summary Get company objectives
 */
export const apiAdmintargetsGetCollection = (
    params?: ApiAdmintargetsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdmintargetsGetCollection200>(
      {url: `/admin/targets`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmintargetsGetCollectionQueryKey = (params?: ApiAdmintargetsGetCollectionParams,) => {
    return [
    `/admin/targets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmintargetsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdmintargetsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmintargetsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>> = ({ signal }) => apiAdmintargetsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmintargetsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>>
export type ApiAdmintargetsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdmintargetsGetCollection<TData = Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdmintargetsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintargetsGetCollection<TData = Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmintargetsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintargetsGetCollection<TData = Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmintargetsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get company objectives
 */

export function useApiAdmintargetsGetCollection<TData = Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdmintargetsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintargetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmintargetsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Import targets
 * @summary Import targets
 */
export const targetsImport = (
    importLogicTypeTargetStatusDtoTargetsImportModel: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportModel | void>(
      {url: `/admin/targets/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importLogicTypeTargetStatusDtoTargetsImportModel, signal
    },
      options);
    }
  


export const getTargetsImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof targetsImport>>, TError,{data: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof targetsImport>>, TError,{data: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>}, TContext> => {

const mutationKey = ['targetsImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof targetsImport>>, {data: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  targetsImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TargetsImportMutationResult = NonNullable<Awaited<ReturnType<typeof targetsImport>>>
    export type TargetsImportMutationBody = BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>
    export type TargetsImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import targets
 */
export const useTargetsImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof targetsImport>>, TError,{data: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof targetsImport>>,
        TError,
        {data: BodyType<ImportLogicTypeTargetStatusDtoTargetsImportModel>},
        TContext
      > => {

      const mutationOptions = getTargetsImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all logic workspaces
 * @summary Get all logic workspaces
 */
export const apiAdminlogicsworkspacesGetCollection = (
    params?: ApiAdminlogicsworkspacesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogicWorkspaceLogicWorkspaceReadModel[]>(
      {url: `/admin/logics/workspaces`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminlogicsworkspacesGetCollectionQueryKey = (params?: ApiAdminlogicsworkspacesGetCollectionParams,) => {
    return [
    `/admin/logics/workspaces`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminlogicsworkspacesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminlogicsworkspacesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminlogicsworkspacesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>> = ({ signal }) => apiAdminlogicsworkspacesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminlogicsworkspacesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>>
export type ApiAdminlogicsworkspacesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminlogicsworkspacesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminlogicsworkspacesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicsworkspacesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicsworkspacesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminlogicsworkspacesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicsworkspacesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all logic workspaces
 */

export function useApiAdminlogicsworkspacesGetCollection<TData = Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminlogicsworkspacesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminlogicsworkspacesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new logic for workspace
 * @summary Create a new logic for workspace
 */
export const apiAdminlogicsworkspacesPost = (
    logicWorkspaceLogicWorkspaceWriteModel: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<LogicWorkspaceLogicWorkspaceReadModel>(
      {url: `/admin/logics/workspaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logicWorkspaceLogicWorkspaceWriteModel, signal
    },
      options);
    }
  


export const getApiAdminlogicsworkspacesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>, TError,{data: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>, TError,{data: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>}, TContext> => {

const mutationKey = ['apiAdminlogicsworkspacesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>, {data: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminlogicsworkspacesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminlogicsworkspacesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>>
    export type ApiAdminlogicsworkspacesPostMutationBody = BodyType<LogicWorkspaceLogicWorkspaceWriteModel>
    export type ApiAdminlogicsworkspacesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new logic for workspace
 */
export const useApiAdminlogicsworkspacesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>, TError,{data: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminlogicsworkspacesPost>>,
        TError,
        {data: BodyType<LogicWorkspaceLogicWorkspaceWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminlogicsworkspacesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a Media resource.
 * @summary Creates a Media resource.
 */
export const apiMediasPost = (
    mediaUploadModel?: BodyType<MediaUploadModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
if(mediaUploadModel?.file !== undefined) {
 formData.append(`file`, mediaUploadModel.file)
 }
if(mediaUploadModel?.type !== undefined) {
 formData.append(`type`, mediaUploadModel.type)
 }

      return customInstance<MediaMediaReadModel>(
      {url: `/medias`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getApiMediasPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMediasPost>>, TError,{data: BodyType<MediaUploadModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMediasPost>>, TError,{data: BodyType<MediaUploadModel>}, TContext> => {

const mutationKey = ['apiMediasPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMediasPost>>, {data: BodyType<MediaUploadModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiMediasPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiMediasPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiMediasPost>>>
    export type ApiMediasPostMutationBody = BodyType<MediaUploadModel>
    export type ApiMediasPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a Media resource.
 */
export const useApiMediasPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMediasPost>>, TError,{data: BodyType<MediaUploadModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiMediasPost>>,
        TError,
        {data: BodyType<MediaUploadModel>},
        TContext
      > => {

      const mutationOptions = getApiMediasPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a Media resource.
 * @summary Retrieves a Media resource.
 */
export const apiMediasIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MediaMediaReadModel>(
      {url: `/medias/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiMediasIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/medias/${id}`
    ] as const;
    }

    
export const getApiMediasIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiMediasIdGet>>, TError = ErrorType<N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiMediasIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiMediasIdGet>>> = ({ signal }) => apiMediasIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiMediasIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiMediasIdGet>>>
export type ApiMediasIdGetQueryError = ErrorType<N404Response>


export function useApiMediasIdGet<TData = Awaited<ReturnType<typeof apiMediasIdGet>>, TError = ErrorType<N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMediasIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiMediasIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMediasIdGet<TData = Awaited<ReturnType<typeof apiMediasIdGet>>, TError = ErrorType<N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiMediasIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiMediasIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiMediasIdGet<TData = Awaited<ReturnType<typeof apiMediasIdGet>>, TError = ErrorType<N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Media resource.
 */

export function useApiMediasIdGet<TData = Awaited<ReturnType<typeof apiMediasIdGet>>, TError = ErrorType<N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiMediasIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiMediasIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Removes the Media resource.
 * @summary Removes the Media resource.
 */
export const apiMediasIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/medias/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiMediasIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMediasIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiMediasIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiMediasIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiMediasIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiMediasIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiMediasIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiMediasIdDelete>>>
    
    export type ApiMediasIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Removes the Media resource.
 */
export const useApiMediasIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiMediasIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiMediasIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiMediasIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get orders
 * @summary Get orders
 */
export const apiOrdersGetCollection = (
    params?: ApiOrdersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiOrdersGetCollection200>(
      {url: `/orders`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiOrdersGetCollectionQueryKey = (params?: ApiOrdersGetCollectionParams,) => {
    return [
    `/orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiOrdersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiOrdersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersGetCollection>>> = ({ signal }) => apiOrdersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersGetCollection>>>
export type ApiOrdersGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiOrdersGetCollection<TData = Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiOrdersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersGetCollection<TData = Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiOrdersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersGetCollection<TData = Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiOrdersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get orders
 */

export function useApiOrdersGetCollection<TData = Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiOrdersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new order
 * @summary Create a new order
 */
export const apiOrdersPost = (
    orderOrderWriteModel: BodyType<OrderOrderWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrderOrderReadModel[]>(
      {url: `/orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: orderOrderWriteModel, signal
    },
      options);
    }
  


export const getApiOrdersPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersPost>>, TError,{data: BodyType<OrderOrderWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiOrdersPost>>, TError,{data: BodyType<OrderOrderWriteModel>}, TContext> => {

const mutationKey = ['apiOrdersPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiOrdersPost>>, {data: BodyType<OrderOrderWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiOrdersPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiOrdersPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiOrdersPost>>>
    export type ApiOrdersPostMutationBody = BodyType<OrderOrderWriteModel>
    export type ApiOrdersPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new order
 */
export const useApiOrdersPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiOrdersPost>>, TError,{data: BodyType<OrderOrderWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiOrdersPost>>,
        TError,
        {data: BodyType<OrderOrderWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiOrdersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get an order
 * @summary Get an order
 */
export const apiOrdersIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<OrderOrderReadModel>(
      {url: `/orders/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiOrdersIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/orders/${id}`
    ] as const;
    }

    
export const getApiOrdersIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiOrdersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiOrdersIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOrdersIdGet>>> = ({ signal }) => apiOrdersIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiOrdersIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiOrdersIdGet>>>
export type ApiOrdersIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiOrdersIdGet<TData = Awaited<ReturnType<typeof apiOrdersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersIdGet<TData = Awaited<ReturnType<typeof apiOrdersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiOrdersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiOrdersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiOrdersIdGet<TData = Awaited<ReturnType<typeof apiOrdersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an order
 */

export function useApiOrdersIdGet<TData = Awaited<ReturnType<typeof apiOrdersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiOrdersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiOrdersIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves the collection of Performance resources.
 * @summary Retrieves the collection of Performance resources.
 */
export const apiAdminperformancesGetCollection = (
    params?: ApiAdminperformancesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminperformancesGetCollection200>(
      {url: `/admin/performances`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminperformancesGetCollectionQueryKey = (params?: ApiAdminperformancesGetCollectionParams,) => {
    return [
    `/admin/performances`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminperformancesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminperformancesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>> = ({ signal }) => apiAdminperformancesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminperformancesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>>
export type ApiAdminperformancesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminperformancesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Performance resources.
 */

export function useApiAdminperformancesGetCollection<TData = Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminperformancesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminperformancesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminperformancesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add a performance
 * @summary Add a performance
 */
export const apiAdminperformancesPost = (
    performancePerformanceImportModel: BodyType<PerformancePerformanceImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PerformancePerformanceReadModel>(
      {url: `/admin/performances`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: performancePerformanceImportModel, signal
    },
      options);
    }
  


export const getApiAdminperformancesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminperformancesPost>>, TError,{data: BodyType<PerformancePerformanceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminperformancesPost>>, TError,{data: BodyType<PerformancePerformanceImportModel>}, TContext> => {

const mutationKey = ['apiAdminperformancesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminperformancesPost>>, {data: BodyType<PerformancePerformanceImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminperformancesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminperformancesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminperformancesPost>>>
    export type ApiAdminperformancesPostMutationBody = BodyType<PerformancePerformanceImportModel>
    export type ApiAdminperformancesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a performance
 */
export const useApiAdminperformancesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminperformancesPost>>, TError,{data: BodyType<PerformancePerformanceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminperformancesPost>>,
        TError,
        {data: BodyType<PerformancePerformanceImportModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminperformancesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import performances
 * @summary Import performances
 */
export const perfsImport = (
    importPerformanceDtoPerformanceImportModel: BodyType<ImportPerformanceDtoPerformanceImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportQueueModel | void>(
      {url: `/admin/performances/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importPerformanceDtoPerformanceImportModel, signal
    },
      options);
    }
  


export const getPerfsImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof perfsImport>>, TError,{data: BodyType<ImportPerformanceDtoPerformanceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof perfsImport>>, TError,{data: BodyType<ImportPerformanceDtoPerformanceImportModel>}, TContext> => {

const mutationKey = ['perfsImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof perfsImport>>, {data: BodyType<ImportPerformanceDtoPerformanceImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  perfsImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PerfsImportMutationResult = NonNullable<Awaited<ReturnType<typeof perfsImport>>>
    export type PerfsImportMutationBody = BodyType<ImportPerformanceDtoPerformanceImportModel>
    export type PerfsImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import performances
 */
export const usePerfsImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof perfsImport>>, TError,{data: BodyType<ImportPerformanceDtoPerformanceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof perfsImport>>,
        TError,
        {data: BodyType<ImportPerformanceDtoPerformanceImportModel>},
        TContext
      > => {

      const mutationOptions = getPerfsImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Point resources.
 * @summary Retrieves the collection of Point resources.
 */
export const apiAdminpointsGetCollection = (
    params?: ApiAdminpointsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminpointsGetCollection200>(
      {url: `/admin/points`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminpointsGetCollectionQueryKey = (params?: ApiAdminpointsGetCollectionParams,) => {
    return [
    `/admin/points`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminpointsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminpointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminpointsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>> = ({ signal }) => apiAdminpointsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminpointsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>>
export type ApiAdminpointsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminpointsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminpointsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpointsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpointsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpointsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpointsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpointsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpointsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Point resources.
 */

export function useApiAdminpointsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpointsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpointsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminpointsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add a point
 * @summary Add a point
 */
export const apiAdminpointsPost = (
    pointPointImportModel: BodyType<PointPointImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PointPointReadModel>(
      {url: `/admin/points`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pointPointImportModel, signal
    },
      options);
    }
  


export const getApiAdminpointsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminpointsPost>>, TError,{data: BodyType<PointPointImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminpointsPost>>, TError,{data: BodyType<PointPointImportModel>}, TContext> => {

const mutationKey = ['apiAdminpointsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminpointsPost>>, {data: BodyType<PointPointImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminpointsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminpointsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminpointsPost>>>
    export type ApiAdminpointsPostMutationBody = BodyType<PointPointImportModel>
    export type ApiAdminpointsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a point
 */
export const useApiAdminpointsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminpointsPost>>, TError,{data: BodyType<PointPointImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminpointsPost>>,
        TError,
        {data: BodyType<PointPointImportModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminpointsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import points
 * @summary Import points
 */
export const pointsImport = (
    importPointDtoPointImportModel: BodyType<ImportPointDtoPointImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportQueueModel | void>(
      {url: `/admin/points/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importPointDtoPointImportModel, signal
    },
      options);
    }
  


export const getPointsImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pointsImport>>, TError,{data: BodyType<ImportPointDtoPointImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof pointsImport>>, TError,{data: BodyType<ImportPointDtoPointImportModel>}, TContext> => {

const mutationKey = ['pointsImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof pointsImport>>, {data: BodyType<ImportPointDtoPointImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  pointsImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PointsImportMutationResult = NonNullable<Awaited<ReturnType<typeof pointsImport>>>
    export type PointsImportMutationBody = BodyType<ImportPointDtoPointImportModel>
    export type PointsImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import points
 */
export const usePointsImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof pointsImport>>, TError,{data: BodyType<ImportPointDtoPointImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof pointsImport>>,
        TError,
        {data: BodyType<ImportPointDtoPointImportModel>},
        TContext
      > => {

      const mutationOptions = getPointsImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create new product
 * @summary Create new product
 */
export const apiAdminproductsPost = (
    productProductWriteModel: BodyType<ProductProductWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductProductReadProductReadSensitiveModel>(
      {url: `/admin/products`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productProductWriteModel, signal
    },
      options);
    }
  


export const getApiAdminproductsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsPost>>, TError,{data: BodyType<ProductProductWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsPost>>, TError,{data: BodyType<ProductProductWriteModel>}, TContext> => {

const mutationKey = ['apiAdminproductsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminproductsPost>>, {data: BodyType<ProductProductWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminproductsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminproductsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminproductsPost>>>
    export type ApiAdminproductsPostMutationBody = BodyType<ProductProductWriteModel>
    export type ApiAdminproductsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create new product
 */
export const useApiAdminproductsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsPost>>, TError,{data: BodyType<ProductProductWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminproductsPost>>,
        TError,
        {data: BodyType<ProductProductWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminproductsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a product
 * @summary Delete a product
 */
export const apiAdminproductsIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/products/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminproductsIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminproductsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminproductsIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminproductsIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminproductsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminproductsIdDelete>>>
    
    export type ApiAdminproductsIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Delete a product
 */
export const useApiAdminproductsIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminproductsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminproductsIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminproductsIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a product
 * @summary Update a product
 */
export const apiAdminshopsShopIdproductsIdPatch = (
    shopId: string | undefined | null,
    id: string | undefined | null,
    productProductUpdateJsonMergePatchModel: BodyType<ProductProductUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductProductReadProductReadSensitiveModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/products/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productProductUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminshopsShopIdproductsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminshopsShopIdproductsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>, {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductUpdateJsonMergePatchModel>}> = (props) => {
          const {shopId,id,data} = props ?? {};

          return  apiAdminshopsShopIdproductsIdPatch(shopId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsShopIdproductsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>>
    export type ApiAdminshopsShopIdproductsIdPatchMutationBody = BodyType<ProductProductUpdateJsonMergePatchModel>
    export type ApiAdminshopsShopIdproductsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a product
 */
export const useApiAdminshopsShopIdproductsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsShopIdproductsIdPatch>>,
        TError,
        {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsShopIdproductsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update the status of a product
 * @summary Update the status of a product
 */
export const updateProductStatus = (
    shopId: string | undefined | null,
    id: string | undefined | null,
    productProductStatusJsonMergePatchModel: BodyType<ProductProductStatusJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductProductReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/products/${encodeURIComponent(String(id))}/status`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productProductStatusJsonMergePatchModel
    },
      options);
    }
  


export const getUpdateProductStatusMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductStatusJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductStatusJsonMergePatchModel>}, TContext> => {

const mutationKey = ['updateProductStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductStatus>>, {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductStatusJsonMergePatchModel>}> = (props) => {
          const {shopId,id,data} = props ?? {};

          return  updateProductStatus(shopId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductStatusMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductStatus>>>
    export type UpdateProductStatusMutationBody = BodyType<ProductProductStatusJsonMergePatchModel>
    export type UpdateProductStatusMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update the status of a product
 */
export const useUpdateProductStatus = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductStatus>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductStatusJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProductStatus>>,
        TError,
        {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductProductStatusJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getUpdateProductStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List products from shop
 * @summary List products from shop
 */
export const apiShopsShopIdproductsGetCollection = (
    shopId: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiShopsShopIdproductsGetCollection200>(
      {url: `/shops/${encodeURIComponent(String(shopId))}/products`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiShopsShopIdproductsGetCollectionQueryKey = (shopId?: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams,) => {
    return [
    `/shops/${shopId}/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiShopsShopIdproductsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(shopId: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsShopIdproductsGetCollectionQueryKey(shopId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>> = ({ signal }) => apiShopsShopIdproductsGetCollection(shopId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsShopIdproductsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>>
export type ApiShopsShopIdproductsGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiShopsShopIdproductsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params: undefined |  ApiShopsShopIdproductsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdproductsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdproductsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List products from shop
 */

export function useApiShopsShopIdproductsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdproductsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsShopIdproductsGetCollectionQueryOptions(shopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a product from shop
 * @summary Get a product from shop
 */
export const apiShopsShopIdproductsIdGet = (
    shopId: string | undefined | null,
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductProductReadModel>(
      {url: `/shops/${encodeURIComponent(String(shopId))}/products/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiShopsShopIdproductsIdGetQueryKey = (shopId?: string | undefined | null,
    id?: string | undefined | null,) => {
    return [
    `/shops/${shopId}/products/${id}`
    ] as const;
    }

    
export const getApiShopsShopIdproductsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(shopId: string | undefined | null,
    id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsShopIdproductsIdGetQueryKey(shopId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>> = ({ signal }) => apiShopsShopIdproductsIdGet(shopId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsShopIdproductsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>>
export type ApiShopsShopIdproductsIdGetQueryError = ErrorType<N400Response | N401Response | N403Response | N404Response>


export function useApiShopsShopIdproductsIdGet<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 shopId: string | undefined | null,
    id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdproductsIdGet<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 shopId: string | undefined | null,
    id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdproductsIdGet<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 shopId: string | undefined | null,
    id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a product from shop
 */

export function useApiShopsShopIdproductsIdGet<TData = Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 shopId: string | undefined | null,
    id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdproductsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsShopIdproductsIdGetQueryOptions(shopId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List product brands from shop
 * @summary List product brands from shop
 */
export const adminBrands = (
    shopId: string | undefined | null,
    params?: AdminBrandsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductBrandProductBrandReadModel[]>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/brands`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminBrandsQueryKey = (shopId?: string | undefined | null,
    params?: AdminBrandsParams,) => {
    return [
    `/admin/shops/${shopId}/brands`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminBrandsQueryOptions = <TData = Awaited<ReturnType<typeof adminBrands>>, TError = ErrorType<N400Response | N401Response | N403Response>>(shopId: string | undefined | null,
    params?: AdminBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminBrandsQueryKey(shopId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminBrands>>> = ({ signal }) => adminBrands(shopId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminBrandsQueryResult = NonNullable<Awaited<ReturnType<typeof adminBrands>>>
export type AdminBrandsQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useAdminBrands<TData = Awaited<ReturnType<typeof adminBrands>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params: undefined |  AdminBrandsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrands>>,
          TError,
          Awaited<ReturnType<typeof adminBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrands<TData = Awaited<ReturnType<typeof adminBrands>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminBrands>>,
          TError,
          Awaited<ReturnType<typeof adminBrands>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminBrands<TData = Awaited<ReturnType<typeof adminBrands>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product brands from shop
 */

export function useAdminBrands<TData = Awaited<ReturnType<typeof adminBrands>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminBrandsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminBrands>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminBrandsQueryOptions(shopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a product brand for a shop
 * @summary Create a product brand for a shop
 */
export const apiAdminshopsShopIdbrandsPost = (
    shopId: string | undefined | null,
    productBrandProductBrandWriteModel: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductBrandProductBrandReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/brands`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productBrandProductBrandWriteModel, signal
    },
      options);
    }
  


export const getApiAdminshopsShopIdbrandsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>, TError,{shopId: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>, TError,{shopId: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>}, TContext> => {

const mutationKey = ['apiAdminshopsShopIdbrandsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>, {shopId: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>}> = (props) => {
          const {shopId,data} = props ?? {};

          return  apiAdminshopsShopIdbrandsPost(shopId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsShopIdbrandsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>>
    export type ApiAdminshopsShopIdbrandsPostMutationBody = BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>
    export type ApiAdminshopsShopIdbrandsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a product brand for a shop
 */
export const useApiAdminshopsShopIdbrandsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>, TError,{shopId: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsPost>>,
        TError,
        {shopId: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteModel>>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsShopIdbrandsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a product brand
 * @summary Update a product brand
 */
export const apiAdminshopsShopIdbrandsIdPatch = (
    shopId: string | undefined | null,
    id: string | undefined | null,
    productBrandProductBrandWriteJsonMergePatchModel: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductBrandProductBrandReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/brands/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productBrandProductBrandWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminshopsShopIdbrandsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>}, TContext> => {

const mutationKey = ['apiAdminshopsShopIdbrandsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>, {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>}> = (props) => {
          const {shopId,id,data} = props ?? {};

          return  apiAdminshopsShopIdbrandsIdPatch(shopId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsShopIdbrandsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>>
    export type ApiAdminshopsShopIdbrandsIdPatchMutationBody = BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>
    export type ApiAdminshopsShopIdbrandsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a product brand
 */
export const useApiAdminshopsShopIdbrandsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsShopIdbrandsIdPatch>>,
        TError,
        {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<NonReadonly<ProductBrandProductBrandWriteJsonMergePatchModel>>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsShopIdbrandsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List product brands from shop
 * @summary List product brands from shop
 */
export const apiShopsShopIdbrandsGetCollection = (
    shopId: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductBrandProductBrandReadModel[]>(
      {url: `/shops/${encodeURIComponent(String(shopId))}/brands`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiShopsShopIdbrandsGetCollectionQueryKey = (shopId?: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams,) => {
    return [
    `/shops/${shopId}/brands`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiShopsShopIdbrandsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(shopId: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsShopIdbrandsGetCollectionQueryKey(shopId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>> = ({ signal }) => apiShopsShopIdbrandsGetCollection(shopId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsShopIdbrandsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>>
export type ApiShopsShopIdbrandsGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiShopsShopIdbrandsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params: undefined |  ApiShopsShopIdbrandsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdbrandsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdbrandsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product brands from shop
 */

export function useApiShopsShopIdbrandsGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdbrandsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdbrandsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsShopIdbrandsGetCollectionQueryOptions(shopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List product categories from shop
 * @summary List product categories from shop
 */
export const adminGetCollection = (
    shopId: string | undefined | null,
    params?: AdminGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminGetCollection200>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/categories`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminGetCollectionQueryKey = (shopId?: string | undefined | null,
    params?: AdminGetCollectionParams,) => {
    return [
    `/admin/shops/${shopId}/categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof adminGetCollection>>, TError = ErrorType<N401Response | N403Response>>(shopId: string | undefined | null,
    params?: AdminGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminGetCollectionQueryKey(shopId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetCollection>>> = ({ signal }) => adminGetCollection(shopId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof adminGetCollection>>>
export type AdminGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useAdminGetCollection<TData = Awaited<ReturnType<typeof adminGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 shopId: string | undefined | null,
    params: undefined |  AdminGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetCollection>>,
          TError,
          Awaited<ReturnType<typeof adminGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetCollection<TData = Awaited<ReturnType<typeof adminGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetCollection>>,
          TError,
          Awaited<ReturnType<typeof adminGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminGetCollection<TData = Awaited<ReturnType<typeof adminGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List product categories from shop
 */

export function useAdminGetCollection<TData = Awaited<ReturnType<typeof adminGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: AdminGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminGetCollectionQueryOptions(shopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a product category for a shop
 * @summary Create a product category for a shop
 */
export const apiAdminshopsShopIdcategoriesPost = (
    shopId: string | undefined | null,
    productCategoryProductCategoryWriteModel: BodyType<ProductCategoryProductCategoryWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductCategoryProductCategoryReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/categories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: productCategoryProductCategoryWriteModel, signal
    },
      options);
    }
  


export const getApiAdminshopsShopIdcategoriesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>, TError,{shopId: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>, TError,{shopId: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteModel>}, TContext> => {

const mutationKey = ['apiAdminshopsShopIdcategoriesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>, {shopId: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteModel>}> = (props) => {
          const {shopId,data} = props ?? {};

          return  apiAdminshopsShopIdcategoriesPost(shopId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsShopIdcategoriesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>>
    export type ApiAdminshopsShopIdcategoriesPostMutationBody = BodyType<ProductCategoryProductCategoryWriteModel>
    export type ApiAdminshopsShopIdcategoriesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a product category for a shop
 */
export const useApiAdminshopsShopIdcategoriesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>, TError,{shopId: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesPost>>,
        TError,
        {shopId: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsShopIdcategoriesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a product category
 * @summary Update a product category
 */
export const apiAdminshopsShopIdcategoriesIdPatch = (
    shopId: string | undefined | null,
    id: string | undefined | null,
    productCategoryProductCategoryWriteJsonMergePatchModel: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ProductCategoryProductCategoryReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(shopId))}/categories/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: productCategoryProductCategoryWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminshopsShopIdcategoriesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminshopsShopIdcategoriesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>, {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>}> = (props) => {
          const {shopId,id,data} = props ?? {};

          return  apiAdminshopsShopIdcategoriesIdPatch(shopId,id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsShopIdcategoriesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>>
    export type ApiAdminshopsShopIdcategoriesIdPatchMutationBody = BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>
    export type ApiAdminshopsShopIdcategoriesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a product category
 */
export const useApiAdminshopsShopIdcategoriesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>, TError,{shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsShopIdcategoriesIdPatch>>,
        TError,
        {shopId: string | undefined | null;id: string | undefined | null;data: BodyType<ProductCategoryProductCategoryWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsShopIdcategoriesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List products categories from shop
 * @summary List products categories from shop
 */
export const apiShopsShopIdcategoriesGetCollection = (
    shopId: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductCategoryProductCategoryReadModel[]>(
      {url: `/shops/${encodeURIComponent(String(shopId))}/categories`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiShopsShopIdcategoriesGetCollectionQueryKey = (shopId?: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams,) => {
    return [
    `/shops/${shopId}/categories`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiShopsShopIdcategoriesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(shopId: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsShopIdcategoriesGetCollectionQueryKey(shopId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>> = ({ signal }) => apiShopsShopIdcategoriesGetCollection(shopId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(shopId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsShopIdcategoriesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>>
export type ApiShopsShopIdcategoriesGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiShopsShopIdcategoriesGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params: undefined |  ApiShopsShopIdcategoriesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdcategoriesGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsShopIdcategoriesGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List products categories from shop
 */

export function useApiShopsShopIdcategoriesGetCollection<TData = Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 shopId: string | undefined | null,
    params?: ApiShopsShopIdcategoriesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsShopIdcategoriesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsShopIdcategoriesGetCollectionQueryOptions(shopId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves the collection of PurchaseProof resources.
 * @summary Retrieves the collection of PurchaseProof resources.
 */
export const apiAdminpurchaseProofsGetCollection = (
    params?: ApiAdminpurchaseProofsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminpurchaseProofsGetCollection200>(
      {url: `/admin/purchase_proofs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminpurchaseProofsGetCollectionQueryKey = (params?: ApiAdminpurchaseProofsGetCollectionParams,) => {
    return [
    `/admin/purchase_proofs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminpurchaseProofsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminpurchaseProofsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminpurchaseProofsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>> = ({ signal }) => apiAdminpurchaseProofsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminpurchaseProofsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>>
export type ApiAdminpurchaseProofsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminpurchaseProofsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminpurchaseProofsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpurchaseProofsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpurchaseProofsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpurchaseProofsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpurchaseProofsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of PurchaseProof resources.
 */

export function useApiAdminpurchaseProofsGetCollection<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminpurchaseProofsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminpurchaseProofsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieves a PurchaseProof resource.
 * @summary Retrieves a PurchaseProof resource.
 */
export const apiAdminpurchaseProofsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PurchaseProofPurchaseProofReadModel>(
      {url: `/admin/purchase_proofs/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminpurchaseProofsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/purchase_proofs/${id}`
    ] as const;
    }

    
export const getApiAdminpurchaseProofsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminpurchaseProofsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>> = ({ signal }) => apiAdminpurchaseProofsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminpurchaseProofsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>>
export type ApiAdminpurchaseProofsIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminpurchaseProofsIdGet<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpurchaseProofsIdGet<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminpurchaseProofsIdGet<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a PurchaseProof resource.
 */

export function useApiAdminpurchaseProofsIdGet<TData = Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminpurchaseProofsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates the PurchaseProof resource.
 * @summary Updates the PurchaseProof resource.
 */
export const apiAdminpurchaseProofsIdPatch = (
    id: string | undefined | null,
    purchaseProofPurchaseProofWriteJsonMergePatchModel: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PurchaseProofPurchaseProofReadModel>(
      {url: `/admin/purchase_proofs/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: purchaseProofPurchaseProofWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminpurchaseProofsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminpurchaseProofsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>, {id: string | undefined | null;data: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminpurchaseProofsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminpurchaseProofsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>>
    export type ApiAdminpurchaseProofsIdPatchMutationBody = BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>
    export type ApiAdminpurchaseProofsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the PurchaseProof resource.
 */
export const useApiAdminpurchaseProofsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminpurchaseProofsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<PurchaseProofPurchaseProofWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminpurchaseProofsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List the purchase proofs submitted by the current Front-User.
 * @summary List my purchase proofs
 */
export const userPurchaseProofs = (
    params?: UserPurchaseProofsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserPurchaseProofs200>(
      {url: `/purchase_proofs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getUserPurchaseProofsQueryKey = (params?: UserPurchaseProofsParams,) => {
    return [
    `/purchase_proofs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getUserPurchaseProofsQueryOptions = <TData = Awaited<ReturnType<typeof userPurchaseProofs>>, TError = ErrorType<N401Response | N403Response>>(params?: UserPurchaseProofsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserPurchaseProofsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof userPurchaseProofs>>> = ({ signal }) => userPurchaseProofs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserPurchaseProofsQueryResult = NonNullable<Awaited<ReturnType<typeof userPurchaseProofs>>>
export type UserPurchaseProofsQueryError = ErrorType<N401Response | N403Response>


export function useUserPurchaseProofs<TData = Awaited<ReturnType<typeof userPurchaseProofs>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  UserPurchaseProofsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPurchaseProofs>>,
          TError,
          Awaited<ReturnType<typeof userPurchaseProofs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserPurchaseProofs<TData = Awaited<ReturnType<typeof userPurchaseProofs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: UserPurchaseProofsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPurchaseProofs>>,
          TError,
          Awaited<ReturnType<typeof userPurchaseProofs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserPurchaseProofs<TData = Awaited<ReturnType<typeof userPurchaseProofs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: UserPurchaseProofsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List my purchase proofs
 */

export function useUserPurchaseProofs<TData = Awaited<ReturnType<typeof userPurchaseProofs>>, TError = ErrorType<N401Response | N403Response>>(
 params?: UserPurchaseProofsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof userPurchaseProofs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getUserPurchaseProofsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Submit a purchase proof from the Front-User. A notification email is sent to Fiddy.
 * @summary Submit a purchase proof
 */
export const apiPurchaseProofsPost = (
    purchaseProofPurchaseProofSubmitModel: BodyType<PurchaseProofPurchaseProofSubmitModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PurchaseProofPurchaseProofReadModel>(
      {url: `/purchase_proofs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: purchaseProofPurchaseProofSubmitModel, signal
    },
      options);
    }
  


export const getApiPurchaseProofsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPurchaseProofsPost>>, TError,{data: BodyType<PurchaseProofPurchaseProofSubmitModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiPurchaseProofsPost>>, TError,{data: BodyType<PurchaseProofPurchaseProofSubmitModel>}, TContext> => {

const mutationKey = ['apiPurchaseProofsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiPurchaseProofsPost>>, {data: BodyType<PurchaseProofPurchaseProofSubmitModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiPurchaseProofsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiPurchaseProofsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiPurchaseProofsPost>>>
    export type ApiPurchaseProofsPostMutationBody = BodyType<PurchaseProofPurchaseProofSubmitModel>
    export type ApiPurchaseProofsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Submit a purchase proof
 */
export const useApiPurchaseProofsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiPurchaseProofsPost>>, TError,{data: BodyType<PurchaseProofPurchaseProofSubmitModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiPurchaseProofsPost>>,
        TError,
        {data: BodyType<PurchaseProofPurchaseProofSubmitModel>},
        TContext
      > => {

      const mutationOptions = getApiPurchaseProofsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import list of references
 * @summary Import list of references
 */
export const referencesImport = (
    importReferenceDtoReferenceImportModel: BodyType<ImportReferenceDtoReferenceImportModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ImportModel | void>(
      {url: `/admin/references/import`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: importReferenceDtoReferenceImportModel
    },
      options);
    }
  


export const getReferencesImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referencesImport>>, TError,{data: BodyType<ImportReferenceDtoReferenceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof referencesImport>>, TError,{data: BodyType<ImportReferenceDtoReferenceImportModel>}, TContext> => {

const mutationKey = ['referencesImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof referencesImport>>, {data: BodyType<ImportReferenceDtoReferenceImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  referencesImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ReferencesImportMutationResult = NonNullable<Awaited<ReturnType<typeof referencesImport>>>
    export type ReferencesImportMutationBody = BodyType<ImportReferenceDtoReferenceImportModel>
    export type ReferencesImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import list of references
 */
export const useReferencesImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof referencesImport>>, TError,{data: BodyType<ImportReferenceDtoReferenceImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof referencesImport>>,
        TError,
        {data: BodyType<ImportReferenceDtoReferenceImportModel>},
        TContext
      > => {

      const mutationOptions = getReferencesImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get references collection
 * @summary Get references collection
 */
export const apiReferencesGetCollection = (
    params?: ApiReferencesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiReferencesGetCollection200>(
      {url: `/references`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiReferencesGetCollectionQueryKey = (params?: ApiReferencesGetCollectionParams,) => {
    return [
    `/references`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiReferencesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiReferencesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiReferencesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiReferencesGetCollection>>> = ({ signal }) => apiReferencesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiReferencesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiReferencesGetCollection>>>
export type ApiReferencesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiReferencesGetCollection<TData = Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiReferencesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiReferencesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiReferencesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiReferencesGetCollection<TData = Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiReferencesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiReferencesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiReferencesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiReferencesGetCollection<TData = Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiReferencesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get references collection
 */

export function useApiReferencesGetCollection<TData = Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiReferencesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiReferencesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiReferencesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get rewards grouped by step
 * @summary Get rewards grouped by step
 */
export const apiAdminrewardsGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RewardGroupedRewardGroupedRewardReadModel[]>(
      {url: `/admin/rewards`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminrewardsGetCollectionQueryKey = () => {
    return [
    `/admin/rewards`
    ] as const;
    }

    
export const getApiAdminrewardsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminrewardsGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>> = ({ signal }) => apiAdminrewardsGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminrewardsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>>
export type ApiAdminrewardsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminrewardsGetCollection<TData = Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminrewardsGetCollection<TData = Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminrewardsGetCollection<TData = Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rewards grouped by step
 */

export function useApiAdminrewardsGetCollection<TData = Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminrewardsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminrewardsGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create new reward
 * @summary Create new reward
 */
export const apiAdminrewardsPost = (
    rewardRewardWriteModel: BodyType<RewardRewardWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RewardRewardReadModel>(
      {url: `/admin/rewards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rewardRewardWriteModel, signal
    },
      options);
    }
  


export const getApiAdminrewardsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsPost>>, TError,{data: BodyType<RewardRewardWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsPost>>, TError,{data: BodyType<RewardRewardWriteModel>}, TContext> => {

const mutationKey = ['apiAdminrewardsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminrewardsPost>>, {data: BodyType<RewardRewardWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminrewardsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminrewardsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminrewardsPost>>>
    export type ApiAdminrewardsPostMutationBody = BodyType<RewardRewardWriteModel>
    export type ApiAdminrewardsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create new reward
 */
export const useApiAdminrewardsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsPost>>, TError,{data: BodyType<RewardRewardWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminrewardsPost>>,
        TError,
        {data: BodyType<RewardRewardWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminrewardsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update the product of a reward. The typology/step association cannot be changed. The product can be set to null (nothing to win for this step).
 * @summary Update the product of a reward
 */
export const apiAdminrewardsIdPatch = (
    id: string | undefined | null,
    rewardRewardPatchJsonMergePatchModel: BodyType<RewardRewardPatchJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RewardRewardReadModel>(
      {url: `/admin/rewards/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: rewardRewardPatchJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminrewardsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<RewardRewardPatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<RewardRewardPatchJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminrewardsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>, {id: string | undefined | null;data: BodyType<RewardRewardPatchJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminrewardsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminrewardsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>>
    export type ApiAdminrewardsIdPatchMutationBody = BodyType<RewardRewardPatchJsonMergePatchModel>
    export type ApiAdminrewardsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update the product of a reward
 */
export const useApiAdminrewardsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<RewardRewardPatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminrewardsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<RewardRewardPatchJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminrewardsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new route
 * @summary Create a new route
 */
export const apiAdminroutesPost = (
    routeRouteWriteModel: BodyType<RouteRouteWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RouteRouteReadModel>(
      {url: `/admin/routes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: routeRouteWriteModel, signal
    },
      options);
    }
  


export const getApiAdminroutesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminroutesPost>>, TError,{data: BodyType<RouteRouteWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminroutesPost>>, TError,{data: BodyType<RouteRouteWriteModel>}, TContext> => {

const mutationKey = ['apiAdminroutesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminroutesPost>>, {data: BodyType<RouteRouteWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminroutesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminroutesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminroutesPost>>>
    export type ApiAdminroutesPostMutationBody = BodyType<RouteRouteWriteModel>
    export type ApiAdminroutesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new route
 */
export const useApiAdminroutesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminroutesPost>>, TError,{data: BodyType<RouteRouteWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminroutesPost>>,
        TError,
        {data: BodyType<RouteRouteWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminroutesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get routes collection
 * @summary Get routes collection
 */
export const apiRoutesGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RouteRouteReadModel[]>(
      {url: `/routes`, method: 'GET', signal
    },
      options);
    }
  



export const getApiRoutesGetCollectionQueryKey = () => {
    return [
    `/routes`
    ] as const;
    }

    
export const getApiRoutesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiRoutesGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiRoutesGetCollection>>> = ({ signal }) => apiRoutesGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiRoutesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiRoutesGetCollection>>>
export type ApiRoutesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiRoutesGetCollection<TData = Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiRoutesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiRoutesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiRoutesGetCollection<TData = Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiRoutesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiRoutesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiRoutesGetCollection<TData = Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get routes collection
 */

export function useApiRoutesGetCollection<TData = Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiRoutesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiRoutesGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the sales hierarchies of the current workspace
 * @summary Get the sales hierarchies of the current workspace
 */
export const apiAdminsalesHierarchiesGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SalesHierarchySalesHierarchyReadModel[]>(
      {url: `/admin/sales-hierarchies`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminsalesHierarchiesGetCollectionQueryKey = () => {
    return [
    `/admin/sales-hierarchies`
    ] as const;
    }

    
export const getApiAdminsalesHierarchiesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsalesHierarchiesGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>> = ({ signal }) => apiAdminsalesHierarchiesGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsalesHierarchiesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>>
export type ApiAdminsalesHierarchiesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminsalesHierarchiesGetCollection<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsalesHierarchiesGetCollection<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsalesHierarchiesGetCollection<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the sales hierarchies of the current workspace
 */

export function useApiAdminsalesHierarchiesGetCollection<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsalesHierarchiesGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new sales hierarchy
 * @summary Create a new sales hierarchy
 */
export const apiAdminsalesHierarchiesPost = (
    salesHierarchySalesHierarchyWriteModel: BodyType<SalesHierarchySalesHierarchyWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SalesHierarchySalesHierarchyReadModel>(
      {url: `/admin/sales-hierarchies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: salesHierarchySalesHierarchyWriteModel, signal
    },
      options);
    }
  


export const getApiAdminsalesHierarchiesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>, TError,{data: BodyType<SalesHierarchySalesHierarchyWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>, TError,{data: BodyType<SalesHierarchySalesHierarchyWriteModel>}, TContext> => {

const mutationKey = ['apiAdminsalesHierarchiesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>, {data: BodyType<SalesHierarchySalesHierarchyWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminsalesHierarchiesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsalesHierarchiesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>>
    export type ApiAdminsalesHierarchiesPostMutationBody = BodyType<SalesHierarchySalesHierarchyWriteModel>
    export type ApiAdminsalesHierarchiesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new sales hierarchy
 */
export const useApiAdminsalesHierarchiesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>, TError,{data: BodyType<SalesHierarchySalesHierarchyWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsalesHierarchiesPost>>,
        TError,
        {data: BodyType<SalesHierarchySalesHierarchyWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsalesHierarchiesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a sales hierarchy
 * @summary Get a sales hierarchy
 */
export const apiAdminsalesHierarchiesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SalesHierarchySalesHierarchyReadModel>(
      {url: `/admin/sales-hierarchies/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminsalesHierarchiesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/sales-hierarchies/${id}`
    ] as const;
    }

    
export const getApiAdminsalesHierarchiesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsalesHierarchiesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>> = ({ signal }) => apiAdminsalesHierarchiesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsalesHierarchiesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>>
export type ApiAdminsalesHierarchiesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminsalesHierarchiesIdGet<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsalesHierarchiesIdGet<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsalesHierarchiesIdGet<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a sales hierarchy
 */

export function useApiAdminsalesHierarchiesIdGet<TData = Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsalesHierarchiesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Deletes the hierarchy along with every parent/child link it contains.
 * @summary Delete a sales hierarchy and all its links
 */
export const apiAdminsalesHierarchiesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/sales-hierarchies/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminsalesHierarchiesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminsalesHierarchiesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminsalesHierarchiesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsalesHierarchiesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>>
    
    export type ApiAdminsalesHierarchiesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Delete a sales hierarchy and all its links
 */
export const useApiAdminsalesHierarchiesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminsalesHierarchiesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Rename a sales hierarchy
 * @summary Rename a sales hierarchy
 */
export const apiAdminsalesHierarchiesIdPatch = (
    id: string | undefined | null,
    salesHierarchySalesHierarchyWriteJsonMergePatchModel: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SalesHierarchySalesHierarchyReadModel>(
      {url: `/admin/sales-hierarchies/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: salesHierarchySalesHierarchyWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminsalesHierarchiesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminsalesHierarchiesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>, {id: string | undefined | null;data: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminsalesHierarchiesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsalesHierarchiesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>>
    export type ApiAdminsalesHierarchiesIdPatchMutationBody = BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>
    export type ApiAdminsalesHierarchiesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Rename a sales hierarchy
 */
export const useApiAdminsalesHierarchiesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsalesHierarchiesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<SalesHierarchySalesHierarchyWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsalesHierarchiesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the nested tree of parent/child links for this hierarchy, one root node per head.
 * @summary Get the sales hierarchy tree for a given hierarchy
 */
export const salesHierarchyLinksTree = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SalesHierarchySalesHierarchyLinkSalesHierarchyLinkTreeReadModel[]>(
      {url: `/admin/sales-hierarchies/${encodeURIComponent(String(id))}/links`, method: 'GET', signal
    },
      options);
    }
  



export const getSalesHierarchyLinksTreeQueryKey = (id?: number | undefined | null,) => {
    return [
    `/admin/sales-hierarchies/${id}/links`
    ] as const;
    }

    
export const getSalesHierarchyLinksTreeQueryOptions = <TData = Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSalesHierarchyLinksTreeQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof salesHierarchyLinksTree>>> = ({ signal }) => salesHierarchyLinksTree(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SalesHierarchyLinksTreeQueryResult = NonNullable<Awaited<ReturnType<typeof salesHierarchyLinksTree>>>
export type SalesHierarchyLinksTreeQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useSalesHierarchyLinksTree<TData = Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesHierarchyLinksTree>>,
          TError,
          Awaited<ReturnType<typeof salesHierarchyLinksTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesHierarchyLinksTree<TData = Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof salesHierarchyLinksTree>>,
          TError,
          Awaited<ReturnType<typeof salesHierarchyLinksTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSalesHierarchyLinksTree<TData = Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the sales hierarchy tree for a given hierarchy
 */

export function useSalesHierarchyLinksTree<TData = Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof salesHierarchyLinksTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSalesHierarchyLinksTreeQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates the parent/child link. If the child already had a parent in the hierarchy, it is re-attached to the new parent only, the rest of its subtree is untouched.
 * @summary Attach a sales to its N-1 (parent) in the hierarchy
 */
export const apiAdminsalesHierarchyLinksPost = (
    salesHierarchyLinkSalesHierarchyLinkWriteModel: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SalesHierarchyLinkSalesHierarchyLinkReadModel>(
      {url: `/admin/sales-hierarchy-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: salesHierarchyLinkSalesHierarchyLinkWriteModel, signal
    },
      options);
    }
  


export const getApiAdminsalesHierarchyLinksPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>, TError,{data: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>, TError,{data: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>}, TContext> => {

const mutationKey = ['apiAdminsalesHierarchyLinksPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>, {data: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminsalesHierarchyLinksPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsalesHierarchyLinksPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>>
    export type ApiAdminsalesHierarchyLinksPostMutationBody = BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>
    export type ApiAdminsalesHierarchyLinksPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Attach a sales to its N-1 (parent) in the hierarchy
 */
export const useApiAdminsalesHierarchyLinksPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>, TError,{data: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksPost>>,
        TError,
        {data: BodyType<SalesHierarchyLinkSalesHierarchyLinkWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsalesHierarchyLinksPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * By default, deletes the link along with every link in the subtree below it. Pass ?cascade=false to instead reattach the child's direct reports to its former parent (the "grandparent"), leaving the rest of their own subtrees untouched.
 * @summary Remove a link, cascading its subtree by default
 */
export const apiAdminsalesHierarchyLinksIdDelete = (
    id: string | undefined | null,
    params?: ApiAdminsalesHierarchyLinksIdDeleteParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/sales-hierarchy-links/${encodeURIComponent(String(id))}`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getApiAdminsalesHierarchyLinksIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>, TError,{id: string | undefined | null;params?: ApiAdminsalesHierarchyLinksIdDeleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>, TError,{id: string | undefined | null;params?: ApiAdminsalesHierarchyLinksIdDeleteParams}, TContext> => {

const mutationKey = ['apiAdminsalesHierarchyLinksIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>, {id: string | undefined | null;params?: ApiAdminsalesHierarchyLinksIdDeleteParams}> = (props) => {
          const {id,params} = props ?? {};

          return  apiAdminsalesHierarchyLinksIdDelete(id,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsalesHierarchyLinksIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>>
    
    export type ApiAdminsalesHierarchyLinksIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Remove a link, cascading its subtree by default
 */
export const useApiAdminsalesHierarchyLinksIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>, TError,{id: string | undefined | null;params?: ApiAdminsalesHierarchyLinksIdDeleteParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsalesHierarchyLinksIdDelete>>,
        TError,
        {id: string | undefined | null;params?: ApiAdminsalesHierarchyLinksIdDeleteParams},
        TContext
      > => {

      const mutationOptions = getApiAdminsalesHierarchyLinksIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all the scheduled tasks
 * @summary Get all the scheduled tasks
 */
export const apiAdminscheduledTasksGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduledTaskScheduledTaskReadModel[]>(
      {url: `/admin/scheduledTasks`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminscheduledTasksGetCollectionQueryKey = () => {
    return [
    `/admin/scheduledTasks`
    ] as const;
    }

    
export const getApiAdminscheduledTasksGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminscheduledTasksGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>> = ({ signal }) => apiAdminscheduledTasksGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminscheduledTasksGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>>
export type ApiAdminscheduledTasksGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiAdminscheduledTasksGetCollection<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminscheduledTasksGetCollection<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminscheduledTasksGetCollection<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all the scheduled tasks
 */

export function useApiAdminscheduledTasksGetCollection<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminscheduledTasksGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a specific scheduled task
 * @summary Get a specific scheduled task
 */
export const apiAdminscheduledTasksIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScheduledTaskScheduledTaskReadModel>(
      {url: `/admin/scheduledTasks/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminscheduledTasksIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/scheduledTasks/${id}`
    ] as const;
    }

    
export const getApiAdminscheduledTasksIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminscheduledTasksIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>> = ({ signal }) => apiAdminscheduledTasksIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminscheduledTasksIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>>
export type ApiAdminscheduledTasksIdGetQueryError = ErrorType<N400Response | N401Response | N403Response | N404Response>


export function useApiAdminscheduledTasksIdGet<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminscheduledTasksIdGet<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminscheduledTasksIdGet<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a specific scheduled task
 */

export function useApiAdminscheduledTasksIdGet<TData = Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError = ErrorType<N400Response | N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminscheduledTasksIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminscheduledTasksIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the list of segment links (in the current workspace) attached to one exact entity.
Each item's "id" is the link identifier, required to detach it via
DELETE /admin/segments/{segmentId}/entities/{id}.

 * @summary Get the segments attached to an entity
 */
export const segmentsForEntity = (
    entityType: string | undefined | null,
    entityId: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentEntitySegmentEntityCollectionReadModel[]>(
      {url: `/admin/entities/${encodeURIComponent(String(entityType))}/${encodeURIComponent(String(entityId))}/segments`, method: 'GET', signal
    },
      options);
    }
  



export const getSegmentsForEntityQueryKey = (entityType?: string | undefined | null,
    entityId?: number | undefined | null,) => {
    return [
    `/admin/entities/${entityType}/${entityId}/segments`
    ] as const;
    }

    
export const getSegmentsForEntityQueryOptions = <TData = Awaited<ReturnType<typeof segmentsForEntity>>, TError = ErrorType<N401Response | N403Response | N404Response>>(entityType: string | undefined | null,
    entityId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSegmentsForEntityQueryKey(entityType,entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof segmentsForEntity>>> = ({ signal }) => segmentsForEntity(entityType,entityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(entityType && entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SegmentsForEntityQueryResult = NonNullable<Awaited<ReturnType<typeof segmentsForEntity>>>
export type SegmentsForEntityQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useSegmentsForEntity<TData = Awaited<ReturnType<typeof segmentsForEntity>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 entityType: string | undefined | null,
    entityId: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof segmentsForEntity>>,
          TError,
          Awaited<ReturnType<typeof segmentsForEntity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSegmentsForEntity<TData = Awaited<ReturnType<typeof segmentsForEntity>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 entityType: string | undefined | null,
    entityId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof segmentsForEntity>>,
          TError,
          Awaited<ReturnType<typeof segmentsForEntity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSegmentsForEntity<TData = Awaited<ReturnType<typeof segmentsForEntity>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 entityType: string | undefined | null,
    entityId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the segments attached to an entity
 */

export function useSegmentsForEntity<TData = Awaited<ReturnType<typeof segmentsForEntity>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 entityType: string | undefined | null,
    entityId: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof segmentsForEntity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSegmentsForEntityQueryOptions(entityType,entityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the list of segments available on the current workspace
 * @summary Get segments collection
 */
export const apiAdminsegmentsGetCollection = (
    params?: ApiAdminsegmentsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminsegmentsGetCollection200>(
      {url: `/admin/segments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminsegmentsGetCollectionQueryKey = (params?: ApiAdminsegmentsGetCollectionParams,) => {
    return [
    `/admin/segments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminsegmentsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminsegmentsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsegmentsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>> = ({ signal }) => apiAdminsegmentsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsegmentsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>>
export type ApiAdminsegmentsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminsegmentsGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminsegmentsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminsegmentsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminsegmentsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get segments collection
 */

export function useApiAdminsegmentsGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminsegmentsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsegmentsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a segment on the current workspace
 * @summary Create a segment
 */
export const apiAdminsegmentsPost = (
    segmentSegmentWriteModel: BodyType<SegmentSegmentWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentSegmentReadModel>(
      {url: `/admin/segments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: segmentSegmentWriteModel, signal
    },
      options);
    }
  


export const getApiAdminsegmentsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsPost>>, TError,{data: BodyType<SegmentSegmentWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsPost>>, TError,{data: BodyType<SegmentSegmentWriteModel>}, TContext> => {

const mutationKey = ['apiAdminsegmentsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentsPost>>, {data: BodyType<SegmentSegmentWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminsegmentsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsPost>>>
    export type ApiAdminsegmentsPostMutationBody = BodyType<SegmentSegmentWriteModel>
    export type ApiAdminsegmentsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a segment
 */
export const useApiAdminsegmentsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsPost>>, TError,{data: BodyType<SegmentSegmentWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentsPost>>,
        TError,
        {data: BodyType<SegmentSegmentWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the list of fields available to build segment rules, with their type, allowed operators, and allowed values for choice fields
 * @summary Get available segment criteria
 */
export const apiAdminsegmentscriteriaGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentCriterionSegmentCriterionReadModel[]>(
      {url: `/admin/segments/criteria`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminsegmentscriteriaGetCollectionQueryKey = () => {
    return [
    `/admin/segments/criteria`
    ] as const;
    }

    
export const getApiAdminsegmentscriteriaGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsegmentscriteriaGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>> = ({ signal }) => apiAdminsegmentscriteriaGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsegmentscriteriaGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>>
export type ApiAdminsegmentscriteriaGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminsegmentscriteriaGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentscriteriaGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentscriteriaGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get available segment criteria
 */

export function useApiAdminsegmentscriteriaGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentscriteriaGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsegmentscriteriaGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Estimate how many workspace members would match the given rules, without creating or updating a segment
 * @summary Preview the number of members matching a set of segment rules
 */
export const apiAdminsegmentspreviewPost = (
    segmentPreviewSegmentPreviewWriteModel: BodyType<SegmentPreviewSegmentPreviewWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentPreviewSegmentPreviewReadModel>(
      {url: `/admin/segments/preview`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: segmentPreviewSegmentPreviewWriteModel, signal
    },
      options);
    }
  


export const getApiAdminsegmentspreviewPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>, TError,{data: BodyType<SegmentPreviewSegmentPreviewWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>, TError,{data: BodyType<SegmentPreviewSegmentPreviewWriteModel>}, TContext> => {

const mutationKey = ['apiAdminsegmentspreviewPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>, {data: BodyType<SegmentPreviewSegmentPreviewWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminsegmentspreviewPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentspreviewPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>>
    export type ApiAdminsegmentspreviewPostMutationBody = BodyType<SegmentPreviewSegmentPreviewWriteModel>
    export type ApiAdminsegmentspreviewPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Preview the number of members matching a set of segment rules
 */
export const useApiAdminsegmentspreviewPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>, TError,{data: BodyType<SegmentPreviewSegmentPreviewWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentspreviewPost>>,
        TError,
        {data: BodyType<SegmentPreviewSegmentPreviewWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentspreviewPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a segment by ID, including its rules
 * @summary Get a segment by ID
 */
export const apiAdminsegmentsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentSegmentReadModel>(
      {url: `/admin/segments/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminsegmentsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/segments/${id}`
    ] as const;
    }

    
export const getApiAdminsegmentsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsegmentsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>> = ({ signal }) => apiAdminsegmentsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsegmentsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>>
export type ApiAdminsegmentsIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminsegmentsIdGet<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsIdGet<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsIdGet<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a segment by ID
 */

export function useApiAdminsegmentsIdGet<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsegmentsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a segment. Its rules are automatically removed with it.
 * @summary Delete a segment
 */
export const apiAdminsegmentsIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/segments/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminsegmentsIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminsegmentsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminsegmentsIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>>
    
    export type ApiAdminsegmentsIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Delete a segment
 */
export const useApiAdminsegmentsIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentsIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentsIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a segment's name and/or description, and replace all its rules
 * @summary Update a segment and its rules
 */
export const apiAdminsegmentsIdPatch = (
    id: string | undefined | null,
    segmentSegmentUpdateJsonMergePatchModel: BodyType<SegmentSegmentUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SegmentSegmentReadModel>(
      {url: `/admin/segments/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: segmentSegmentUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminsegmentsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SegmentSegmentUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SegmentSegmentUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminsegmentsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>, {id: string | undefined | null;data: BodyType<SegmentSegmentUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminsegmentsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>>
    export type ApiAdminsegmentsIdPatchMutationBody = BodyType<SegmentSegmentUpdateJsonMergePatchModel>
    export type ApiAdminsegmentsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a segment and its rules
 */
export const useApiAdminsegmentsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<SegmentSegmentUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<SegmentSegmentUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the list of workspace members (UserWorkspace) matching all rules of a segment
 * @summary Get members matching a segment
 */
export const apiAdminsegmentsIdmembersGetCollection = (
    id: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminsegmentsIdmembersGetCollection200>(
      {url: `/admin/segments/${encodeURIComponent(String(id))}/members`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminsegmentsIdmembersGetCollectionQueryKey = (id?: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams,) => {
    return [
    `/admin/segments/${id}/members`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminsegmentsIdmembersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminsegmentsIdmembersGetCollectionQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>> = ({ signal }) => apiAdminsegmentsIdmembersGetCollection(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminsegmentsIdmembersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>>
export type ApiAdminsegmentsIdmembersGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminsegmentsIdmembersGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null,
    params: undefined |  ApiAdminsegmentsIdmembersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsIdmembersGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminsegmentsIdmembersGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get members matching a segment
 */

export function useApiAdminsegmentsIdmembersGetCollection<TData = Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: number | undefined | null,
    params?: ApiAdminsegmentsIdmembersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminsegmentsIdmembersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminsegmentsIdmembersGetCollectionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Attach a segment to an entity
 * @summary Attach a segment to an entity
 */
export const apiAdminsegmentsSegmentIdentitiesPost = (
    segmentId: number | undefined | null,
    segmentEntitySegmentEntityWriteModel: BodyType<SegmentEntitySegmentEntityWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SegmentEntitySegmentEntityReadModel>(
      {url: `/admin/segments/${encodeURIComponent(String(segmentId))}/entities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: segmentEntitySegmentEntityWriteModel, signal
    },
      options);
    }
  


export const getApiAdminsegmentsSegmentIdentitiesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>, TError,{segmentId: number | undefined | null;data: BodyType<SegmentEntitySegmentEntityWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>, TError,{segmentId: number | undefined | null;data: BodyType<SegmentEntitySegmentEntityWriteModel>}, TContext> => {

const mutationKey = ['apiAdminsegmentsSegmentIdentitiesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>, {segmentId: number | undefined | null;data: BodyType<SegmentEntitySegmentEntityWriteModel>}> = (props) => {
          const {segmentId,data} = props ?? {};

          return  apiAdminsegmentsSegmentIdentitiesPost(segmentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentsSegmentIdentitiesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>>
    export type ApiAdminsegmentsSegmentIdentitiesPostMutationBody = BodyType<SegmentEntitySegmentEntityWriteModel>
    export type ApiAdminsegmentsSegmentIdentitiesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Attach a segment to an entity
 */
export const useApiAdminsegmentsSegmentIdentitiesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>, TError,{segmentId: number | undefined | null;data: BodyType<SegmentEntitySegmentEntityWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesPost>>,
        TError,
        {segmentId: number | undefined | null;data: BodyType<SegmentEntitySegmentEntityWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentsSegmentIdentitiesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Detach a segment from an entity, removing the conditioning
 * @summary Detach a segment from an entity
 */
export const apiAdminsegmentsSegmentIdentitiesIdDelete = (
    segmentId: number | undefined | null,
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/segments/${encodeURIComponent(String(segmentId))}/entities/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminsegmentsSegmentIdentitiesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>, TError,{segmentId: number | undefined | null;id: number | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>, TError,{segmentId: number | undefined | null;id: number | undefined | null}, TContext> => {

const mutationKey = ['apiAdminsegmentsSegmentIdentitiesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>, {segmentId: number | undefined | null;id: number | undefined | null}> = (props) => {
          const {segmentId,id} = props ?? {};

          return  apiAdminsegmentsSegmentIdentitiesIdDelete(segmentId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminsegmentsSegmentIdentitiesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>>
    
    export type ApiAdminsegmentsSegmentIdentitiesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Detach a segment from an entity
 */
export const useApiAdminsegmentsSegmentIdentitiesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>, TError,{segmentId: number | undefined | null;id: number | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminsegmentsSegmentIdentitiesIdDelete>>,
        TError,
        {segmentId: number | undefined | null;id: number | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminsegmentsSegmentIdentitiesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Create a new shop
 * @summary Create a new shop
 */
export const apiAdminshopsPost = (
    shopShopWriteModel: BodyType<ShopShopWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ShopShopReadModel>(
      {url: `/admin/shops`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shopShopWriteModel, signal
    },
      options);
    }
  


export const getApiAdminshopsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsPost>>, TError,{data: BodyType<ShopShopWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsPost>>, TError,{data: BodyType<ShopShopWriteModel>}, TContext> => {

const mutationKey = ['apiAdminshopsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsPost>>, {data: BodyType<ShopShopWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminshopsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsPost>>>
    export type ApiAdminshopsPostMutationBody = BodyType<ShopShopWriteModel>
    export type ApiAdminshopsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new shop
 */
export const useApiAdminshopsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsPost>>, TError,{data: BodyType<ShopShopWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsPost>>,
        TError,
        {data: BodyType<ShopShopWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a shop
 * @summary Update a shop
 */
export const apiAdminshopsIdPatch = (
    id: string | undefined | null,
    shopShopUpdateJsonMergePatchModel: BodyType<ShopShopUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ShopShopReadModel>(
      {url: `/admin/shops/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: shopShopUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminshopsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopShopUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopShopUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminshopsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopsIdPatch>>, {id: string | undefined | null;data: BodyType<ShopShopUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminshopsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopsIdPatch>>>
    export type ApiAdminshopsIdPatchMutationBody = BodyType<ShopShopUpdateJsonMergePatchModel>
    export type ApiAdminshopsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a shop
 */
export const useApiAdminshopsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopShopUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<ShopShopUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * If user is admin, list all shops, otherwise list only shops accessible by user
 * @summary List all shops
 */
export const apiShopsGetCollection = (
    params?: ApiShopsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiShopsGetCollection200>(
      {url: `/shops`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiShopsGetCollectionQueryKey = (params?: ApiShopsGetCollectionParams,) => {
    return [
    `/shops`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiShopsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(params?: ApiShopsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsGetCollection>>> = ({ signal }) => apiShopsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsGetCollection>>>
export type ApiShopsGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiShopsGetCollection<TData = Awaited<ReturnType<typeof apiShopsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params: undefined |  ApiShopsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsGetCollection<TData = Awaited<ReturnType<typeof apiShopsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiShopsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiShopsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsGetCollection<TData = Awaited<ReturnType<typeof apiShopsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiShopsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all shops
 */

export function useApiShopsGetCollection<TData = Awaited<ReturnType<typeof apiShopsGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiShopsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Rules are the same as for listing all shops
 * @summary List specific shop
 */
export const apiShopsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ShopShopReadModel>(
      {url: `/shops/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiShopsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/shops/${id}`
    ] as const;
    }

    
export const getApiShopsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiShopsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiShopsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiShopsIdGet>>> = ({ signal }) => apiShopsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiShopsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiShopsIdGet>>>
export type ApiShopsIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiShopsIdGet<TData = Awaited<ReturnType<typeof apiShopsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiShopsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsIdGet<TData = Awaited<ReturnType<typeof apiShopsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiShopsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiShopsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiShopsIdGet<TData = Awaited<ReturnType<typeof apiShopsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List specific shop
 */

export function useApiShopsIdGet<TData = Awaited<ReturnType<typeof apiShopsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiShopsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiShopsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Link a shop to active workspace
 * @summary Link a shop to active workspace
 */
export const apiAdminshopWorkspacesPost = (
    shopWorkspaceShopWorkspaceWriteModel: BodyType<ShopWorkspaceShopWorkspaceWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ShopWorkspaceShopWorkspaceReadModel>(
      {url: `/admin/shopWorkspaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: shopWorkspaceShopWorkspaceWriteModel, signal
    },
      options);
    }
  


export const getApiAdminshopWorkspacesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>, TError,{data: BodyType<ShopWorkspaceShopWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>, TError,{data: BodyType<ShopWorkspaceShopWorkspaceWriteModel>}, TContext> => {

const mutationKey = ['apiAdminshopWorkspacesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>, {data: BodyType<ShopWorkspaceShopWorkspaceWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminshopWorkspacesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopWorkspacesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>>
    export type ApiAdminshopWorkspacesPostMutationBody = BodyType<ShopWorkspaceShopWorkspaceWriteModel>
    export type ApiAdminshopWorkspacesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Link a shop to active workspace
 */
export const useApiAdminshopWorkspacesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>, TError,{data: BodyType<ShopWorkspaceShopWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopWorkspacesPost>>,
        TError,
        {data: BodyType<ShopWorkspaceShopWorkspaceWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopWorkspacesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a shopWorkspace
 * @summary Delete a shopWorkspace
 */
export const apiAdminshopWorkspacesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/shopWorkspaces/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminshopWorkspacesIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminshopWorkspacesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminshopWorkspacesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopWorkspacesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>>
    
    export type ApiAdminshopWorkspacesIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Delete a shopWorkspace
 */
export const useApiAdminshopWorkspacesIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopWorkspacesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminshopWorkspacesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a shopWorkspace
 * @summary Update a shopWorkspace
 */
export const apiAdminshopWorkspacesIdPatch = (
    id: string | undefined | null,
    shopWorkspaceShopWorkspaceUpdateJsonMergePatchModel: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ShopWorkspaceShopWorkspaceReadModel>(
      {url: `/admin/shopWorkspaces/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: shopWorkspaceShopWorkspaceUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminshopWorkspacesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminshopWorkspacesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>, {id: string | undefined | null;data: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminshopWorkspacesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminshopWorkspacesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>>
    export type ApiAdminshopWorkspacesIdPatchMutationBody = BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>
    export type ApiAdminshopWorkspacesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a shopWorkspace
 */
export const useApiAdminshopWorkspacesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminshopWorkspacesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminshopWorkspacesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List all typologies
 * @summary List all typologies
 */
export const apiAdmintypologiesGetCollection = (
    params?: ApiAdmintypologiesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdmintypologiesGetCollection200>(
      {url: `/admin/typologies`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdmintypologiesGetCollectionQueryKey = (params?: ApiAdmintypologiesGetCollectionParams,) => {
    return [
    `/admin/typologies`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdmintypologiesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(params?: ApiAdmintypologiesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmintypologiesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>> = ({ signal }) => apiAdmintypologiesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmintypologiesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>>
export type ApiAdmintypologiesGetCollectionQueryError = ErrorType<N400Response | N401Response | N403Response>


export function useApiAdmintypologiesGetCollection<TData = Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params: undefined |  ApiAdmintypologiesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintypologiesGetCollection<TData = Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiAdmintypologiesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintypologiesGetCollection<TData = Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiAdmintypologiesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all typologies
 */

export function useApiAdmintypologiesGetCollection<TData = Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError = ErrorType<N400Response | N401Response | N403Response>>(
 params?: ApiAdmintypologiesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmintypologiesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new typology
 * @summary Create a new typology
 */
export const apiAdmintypologiesPost = (
    typologyTypologyWriteModel: BodyType<TypologyTypologyWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TypologyTypologyReadModel>(
      {url: `/admin/typologies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: typologyTypologyWriteModel, signal
    },
      options);
    }
  


export const getApiAdmintypologiesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesPost>>, TError,{data: BodyType<TypologyTypologyWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesPost>>, TError,{data: BodyType<TypologyTypologyWriteModel>}, TContext> => {

const mutationKey = ['apiAdmintypologiesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmintypologiesPost>>, {data: BodyType<TypologyTypologyWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdmintypologiesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmintypologiesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmintypologiesPost>>>
    export type ApiAdmintypologiesPostMutationBody = BodyType<TypologyTypologyWriteModel>
    export type ApiAdmintypologiesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new typology
 */
export const useApiAdmintypologiesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesPost>>, TError,{data: BodyType<TypologyTypologyWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmintypologiesPost>>,
        TError,
        {data: BodyType<TypologyTypologyWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmintypologiesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get typologies by ID
 * @summary Get typologies by ID
 */
export const apiAdmintypologiesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TypologyTypologyReadModel>(
      {url: `/admin/typologies/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdmintypologiesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/typologies/${id}`
    ] as const;
    }

    
export const getApiAdmintypologiesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdmintypologiesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>> = ({ signal }) => apiAdmintypologiesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdmintypologiesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>>
export type ApiAdmintypologiesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdmintypologiesIdGet<TData = Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintypologiesIdGet<TData = Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdmintypologiesIdGet<TData = Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get typologies by ID
 */

export function useApiAdmintypologiesIdGet<TData = Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdmintypologiesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a typology. Companies linked to this typology are automatically transferred to the workspace default typology.
 * @summary Delete a typology
 */
export const apiAdmintypologiesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/typologies/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdmintypologiesIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdmintypologiesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdmintypologiesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmintypologiesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>>
    
    export type ApiAdmintypologiesIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Delete a typology
 */
export const useApiAdmintypologiesIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmintypologiesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdmintypologiesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a typology
 * @summary Update a typology
 */
export const apiAdmintypologiesIdPatch = (
    id: string | undefined | null,
    typologyTypologyUpdateJsonMergePatchModel: BodyType<TypologyTypologyUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TypologyTypologyReadModel>(
      {url: `/admin/typologies/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: typologyTypologyUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdmintypologiesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<TypologyTypologyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<TypologyTypologyUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdmintypologiesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>, {id: string | undefined | null;data: BodyType<TypologyTypologyUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdmintypologiesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdmintypologiesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>>
    export type ApiAdmintypologiesIdPatchMutationBody = BodyType<TypologyTypologyUpdateJsonMergePatchModel>
    export type ApiAdmintypologiesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a typology
 */
export const useApiAdmintypologiesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<TypologyTypologyUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdmintypologiesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<TypologyTypologyUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdmintypologiesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of User resources.
 * @summary Retrieves the collection of User resources.
 */
export const apiAdminusersGetCollection = (
    params?: ApiAdminusersGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminusersGetCollection200>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminusersGetCollectionQueryKey = (params?: ApiAdminusersGetCollectionParams,) => {
    return [
    `/admin/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminusersGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminusersGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminusersGetCollection>>> = ({ signal }) => apiAdminusersGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminusersGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersGetCollection>>>
export type ApiAdminusersGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminusersGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminusersGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of User resources.
 */

export function useApiAdminusersGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminusersGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminusersGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add a new user
 * @summary Add a new user
 */
export const apiAdminusersPost = (
    userUserImportModel: BodyType<UserUserImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserUserReadModel>(
      {url: `/admin/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userUserImportModel, signal
    },
      options);
    }
  


export const getApiAdminusersPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersPost>>, TError,{data: BodyType<UserUserImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersPost>>, TError,{data: BodyType<UserUserImportModel>}, TContext> => {

const mutationKey = ['apiAdminusersPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminusersPost>>, {data: BodyType<UserUserImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminusersPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminusersPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersPost>>>
    export type ApiAdminusersPostMutationBody = BodyType<UserUserImportModel>
    export type ApiAdminusersPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add a new user
 */
export const useApiAdminusersPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersPost>>, TError,{data: BodyType<UserUserImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminusersPost>>,
        TError,
        {data: BodyType<UserUserImportModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminusersPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Import list of users
 * @summary Import list of users
 */
export const usersImport = (
    importUserDtoUserImportModel: BodyType<ImportUserDtoUserImportModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ImportQueueModel | void>(
      {url: `/admin/users/import`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importUserDtoUserImportModel, signal
    },
      options);
    }
  


export const getUsersImportMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersImport>>, TError,{data: BodyType<ImportUserDtoUserImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof usersImport>>, TError,{data: BodyType<ImportUserDtoUserImportModel>}, TContext> => {

const mutationKey = ['usersImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersImport>>, {data: BodyType<ImportUserDtoUserImportModel>}> = (props) => {
          const {data} = props ?? {};

          return  usersImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UsersImportMutationResult = NonNullable<Awaited<ReturnType<typeof usersImport>>>
    export type UsersImportMutationBody = BodyType<ImportUserDtoUserImportModel>
    export type UsersImportMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Import list of users
 */
export const useUsersImport = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof usersImport>>, TError,{data: BodyType<ImportUserDtoUserImportModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof usersImport>>,
        TError,
        {data: BodyType<ImportUserDtoUserImportModel>},
        TContext
      > => {

      const mutationOptions = getUsersImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Switch from one workspace to another
 * @summary Switch from one workspace to another
 */
export const switchToWorkspace = (
    switchWorkspaceModel?: BodyType<SwitchWorkspaceModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<JWTTokenModel>(
      {url: `/admin/users/me/switchTo`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: switchWorkspaceModel
    },
      options);
    }
  


export const getSwitchToWorkspaceMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchToWorkspace>>, TError,{data: BodyType<SwitchWorkspaceModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof switchToWorkspace>>, TError,{data: BodyType<SwitchWorkspaceModel>}, TContext> => {

const mutationKey = ['switchToWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof switchToWorkspace>>, {data: BodyType<SwitchWorkspaceModel>}> = (props) => {
          const {data} = props ?? {};

          return  switchToWorkspace(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SwitchToWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof switchToWorkspace>>>
    export type SwitchToWorkspaceMutationBody = BodyType<SwitchWorkspaceModel>
    export type SwitchToWorkspaceMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Switch from one workspace to another
 */
export const useSwitchToWorkspace = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof switchToWorkspace>>, TError,{data: BodyType<SwitchWorkspaceModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof switchToWorkspace>>,
        TError,
        {data: BodyType<SwitchWorkspaceModel>},
        TContext
      > => {

      const mutationOptions = getSwitchToWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a User resource.
 * @summary Retrieves a User resource.
 */
export const apiAdminusersIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserUserReadModel>(
      {url: `/admin/users/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminusersIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/users/${id}`
    ] as const;
    }

    
export const getApiAdminusersIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminusersIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminusersIdGet>>> = ({ signal }) => apiAdminusersIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminusersIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersIdGet>>>
export type ApiAdminusersIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminusersIdGet<TData = Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdGet<TData = Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdGet<TData = Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a User resource.
 */

export function useApiAdminusersIdGet<TData = Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminusersIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Anonymize and soft-delete a user
 * @summary Soft-delete a user
 */
export const apiAdminusersIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminusersIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminusersIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminusersIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminusersIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminusersIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersIdDelete>>>
    
    export type ApiAdminusersIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Soft-delete a user
 */
export const useApiAdminusersIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminusersIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminusersIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminusersIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete the previous magic link (if needed) and send a new one to the user
 * @summary Send a magic link to a user
 */
export const sendMagicLink = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/users/${encodeURIComponent(String(id))}/sendMagicLink`, method: 'POST', signal
    },
      options);
    }
  


export const getSendMagicLinkMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMagicLink>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendMagicLink>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['sendMagicLink'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendMagicLink>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  sendMagicLink(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendMagicLinkMutationResult = NonNullable<Awaited<ReturnType<typeof sendMagicLink>>>
    
    export type SendMagicLinkMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Send a magic link to a user
 */
export const useSendMagicLink = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendMagicLink>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendMagicLink>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getSendMagicLinkMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Send a first connexion email to a user
 * @summary Send a first connexion email to a user
 */
export const sendFirstConnexion = (
    userUserSendFirstConnexionModel: BodyType<UserUserSendFirstConnexionModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/auth/sendFirstConnexion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userUserSendFirstConnexionModel, signal
    },
      options);
    }
  


export const getSendFirstConnexionMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendFirstConnexion>>, TError,{data: BodyType<UserUserSendFirstConnexionModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sendFirstConnexion>>, TError,{data: BodyType<UserUserSendFirstConnexionModel>}, TContext> => {

const mutationKey = ['sendFirstConnexion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sendFirstConnexion>>, {data: BodyType<UserUserSendFirstConnexionModel>}> = (props) => {
          const {data} = props ?? {};

          return  sendFirstConnexion(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SendFirstConnexionMutationResult = NonNullable<Awaited<ReturnType<typeof sendFirstConnexion>>>
    export type SendFirstConnexionMutationBody = BodyType<UserUserSendFirstConnexionModel>
    export type SendFirstConnexionMutationError = ErrorType<ErrorJsonldModel | ErrorModel | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Send a first connexion email to a user
 */
export const useSendFirstConnexion = <TError = ErrorType<ErrorJsonldModel | ErrorModel | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sendFirstConnexion>>, TError,{data: BodyType<UserUserSendFirstConnexionModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sendFirstConnexion>>,
        TError,
        {data: BodyType<UserUserSendFirstConnexionModel>},
        TContext
      > => {

      const mutationOptions = getSendFirstConnexionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a User resource.
 * @summary Retrieves a User resource.
 */
export const me = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserMeReadModel>(
      {url: `/users/me`, method: 'GET', signal
    },
      options);
    }
  



export const getMeQueryKey = () => {
    return [
    `/users/me`
    ] as const;
    }

    
export const getMeQueryOptions = <TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<N401Response | N404Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof me>>> = ({ signal }) => me(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MeQueryResult = NonNullable<Awaited<ReturnType<typeof me>>>
export type MeQueryError = ErrorType<N401Response | N404Response>


export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<N401Response | N404Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<N401Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof me>>,
          TError,
          Awaited<ReturnType<typeof me>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<N401Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a User resource.
 */

export function useMe<TData = Awaited<ReturnType<typeof me>>, TError = ErrorType<N401Response | N404Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof me>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update password
 * @summary Update password
 */
export const passwordUpdate = (
    passwordUpdateModel?: BodyType<PasswordUpdateModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserMeReadModel>(
      {url: `/users/me/passwordUpdate`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: passwordUpdateModel
    },
      options);
    }
  


export const getPasswordUpdateMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordUpdate>>, TError,{data: BodyType<PasswordUpdateModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof passwordUpdate>>, TError,{data: BodyType<PasswordUpdateModel>}, TContext> => {

const mutationKey = ['passwordUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordUpdate>>, {data: BodyType<PasswordUpdateModel>}> = (props) => {
          const {data} = props ?? {};

          return  passwordUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PasswordUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof passwordUpdate>>>
    export type PasswordUpdateMutationBody = BodyType<PasswordUpdateModel>
    export type PasswordUpdateMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update password
 */
export const usePasswordUpdate = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordUpdate>>, TError,{data: BodyType<PasswordUpdateModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof passwordUpdate>>,
        TError,
        {data: BodyType<PasswordUpdateModel>},
        TContext
      > => {

      const mutationOptions = getPasswordUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Accept terms of use
 * @summary Accept terms of use
 */
export const profileUpdate = (
    profileUpdateBody?: BodyType<ProfileUpdateBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserMeReadModel>(
      {url: `/users/me/profileUpdate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: profileUpdateBody, signal
    },
      options);
    }
  


export const getProfileUpdateMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profileUpdate>>, TError,{data: BodyType<ProfileUpdateBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof profileUpdate>>, TError,{data: BodyType<ProfileUpdateBody>}, TContext> => {

const mutationKey = ['profileUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof profileUpdate>>, {data: BodyType<ProfileUpdateBody>}> = (props) => {
          const {data} = props ?? {};

          return  profileUpdate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ProfileUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof profileUpdate>>>
    export type ProfileUpdateMutationBody = BodyType<ProfileUpdateBody>
    export type ProfileUpdateMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Accept terms of use
 */
export const useProfileUpdate = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof profileUpdate>>, TError,{data: BodyType<ProfileUpdateBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof profileUpdate>>,
        TError,
        {data: BodyType<ProfileUpdateBody>},
        TContext
      > => {

      const mutationOptions = getProfileUpdateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the User resource.
 * @summary Updates the User resource.
 */
export const apiUsersIdPatch = (
    id: string | undefined | null,
    userUserUpdateJsonMergePatchModel: BodyType<UserUserUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserUserReadModel>(
      {url: `/users/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: userUserUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiUsersIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUsersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<UserUserUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiUsersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<UserUserUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiUsersIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiUsersIdPatch>>, {id: string | undefined | null;data: BodyType<UserUserUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiUsersIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiUsersIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiUsersIdPatch>>>
    export type ApiUsersIdPatchMutationBody = BodyType<UserUserUpdateJsonMergePatchModel>
    export type ApiUsersIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the User resource.
 */
export const useApiUsersIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiUsersIdPatch>>, TError,{id: string | undefined | null;data: BodyType<UserUserUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiUsersIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<UserUserUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiUsersIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get history for a user
 * @summary Get history for a user
 */
export const apiAdminusersIdhistoryGetCollection = (
    id: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminusersIdhistoryGetCollection200>(
      {url: `/admin/users/${encodeURIComponent(String(id))}/history`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminusersIdhistoryGetCollectionQueryKey = (id?: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams,) => {
    return [
    `/admin/users/${id}/history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminusersIdhistoryGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminusersIdhistoryGetCollectionQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>> = ({ signal }) => apiAdminusersIdhistoryGetCollection(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminusersIdhistoryGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>>
export type ApiAdminusersIdhistoryGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminusersIdhistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params: undefined |  ApiAdminusersIdhistoryGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdhistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdhistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get history for a user
 */

export function useApiAdminusersIdhistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdhistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdhistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminusersIdhistoryGetCollectionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get login history for a user
 * @summary Get login history for a user
 */
export const apiAdminusersIdloginHistoryGetCollection = (
    id: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminusersIdloginHistoryGetCollection200>(
      {url: `/admin/users/${encodeURIComponent(String(id))}/loginHistory`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminusersIdloginHistoryGetCollectionQueryKey = (id?: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams,) => {
    return [
    `/admin/users/${id}/loginHistory`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminusersIdloginHistoryGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminusersIdloginHistoryGetCollectionQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>> = ({ signal }) => apiAdminusersIdloginHistoryGetCollection(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminusersIdloginHistoryGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>>
export type ApiAdminusersIdloginHistoryGetCollectionQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminusersIdloginHistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params: undefined |  ApiAdminusersIdloginHistoryGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdloginHistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminusersIdloginHistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get login history for a user
 */

export function useApiAdminusersIdloginHistoryGetCollection<TData = Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null,
    params?: ApiAdminusersIdloginHistoryGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminusersIdloginHistoryGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminusersIdloginHistoryGetCollectionQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a scheduled task for the current user
 * @summary Create a scheduled task for the current user
 */
export const apiAdminuserScheduledTasksPost = (
    userScheduledTaskUserScheduledTaskWriteModel: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserScheduledTaskUserScheduledTaskReadModel>(
      {url: `/admin/userScheduledTasks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userScheduledTaskUserScheduledTaskWriteModel, signal
    },
      options);
    }
  


export const getApiAdminuserScheduledTasksPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>, TError,{data: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>, TError,{data: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>}, TContext> => {

const mutationKey = ['apiAdminuserScheduledTasksPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>, {data: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminuserScheduledTasksPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminuserScheduledTasksPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>>
    export type ApiAdminuserScheduledTasksPostMutationBody = BodyType<UserScheduledTaskUserScheduledTaskWriteModel>
    export type ApiAdminuserScheduledTasksPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a scheduled task for the current user
 */
export const useApiAdminuserScheduledTasksPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>, TError,{data: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminuserScheduledTasksPost>>,
        TError,
        {data: BodyType<UserScheduledTaskUserScheduledTaskWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminuserScheduledTasksPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a scheduled task by id
 * @summary Delete a scheduled task by id
 */
export const apiAdminuserScheduledTasksIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/userScheduledTasks/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminuserScheduledTasksIdDeleteMutationOptions = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminuserScheduledTasksIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminuserScheduledTasksIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminuserScheduledTasksIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>>
    
    export type ApiAdminuserScheduledTasksIdDeleteMutationError = ErrorType<N400Response | N401Response | N403Response | N404Response>

    /**
 * @summary Delete a scheduled task by id
 */
export const useApiAdminuserScheduledTasksIdDelete = <TError = ErrorType<N400Response | N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminuserScheduledTasksIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminuserScheduledTasksIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get the list of video notices
 * @summary Get video notices collection
 */
export const apiAdminvideoNoticesGetCollection = (
    params?: ApiAdminvideoNoticesGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminvideoNoticesGetCollection200>(
      {url: `/admin/videoNotices`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminvideoNoticesGetCollectionQueryKey = (params?: ApiAdminvideoNoticesGetCollectionParams,) => {
    return [
    `/admin/videoNotices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminvideoNoticesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminvideoNoticesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminvideoNoticesGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>> = ({ signal }) => apiAdminvideoNoticesGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminvideoNoticesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>>
export type ApiAdminvideoNoticesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminvideoNoticesGetCollection<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminvideoNoticesGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminvideoNoticesGetCollection<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminvideoNoticesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminvideoNoticesGetCollection<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminvideoNoticesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get video notices collection
 */

export function useApiAdminvideoNoticesGetCollection<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminvideoNoticesGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminvideoNoticesGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a video notice
 * @summary Create a video notice
 */
export const apiAdminvideoNoticesPost = (
    videoNoticeVideoNoticeWriteModel: BodyType<VideoNoticeVideoNoticeWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<VideoNoticeVideoNoticeReadModel>(
      {url: `/admin/videoNotices`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: videoNoticeVideoNoticeWriteModel, signal
    },
      options);
    }
  


export const getApiAdminvideoNoticesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>, TError,{data: BodyType<VideoNoticeVideoNoticeWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>, TError,{data: BodyType<VideoNoticeVideoNoticeWriteModel>}, TContext> => {

const mutationKey = ['apiAdminvideoNoticesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>, {data: BodyType<VideoNoticeVideoNoticeWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminvideoNoticesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminvideoNoticesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>>
    export type ApiAdminvideoNoticesPostMutationBody = BodyType<VideoNoticeVideoNoticeWriteModel>
    export type ApiAdminvideoNoticesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a video notice
 */
export const useApiAdminvideoNoticesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>, TError,{data: BodyType<VideoNoticeVideoNoticeWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminvideoNoticesPost>>,
        TError,
        {data: BodyType<VideoNoticeVideoNoticeWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminvideoNoticesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a video notice by ID
 * @summary Get a video notice by ID
 */
export const apiAdminvideoNoticesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<VideoNoticeVideoNoticeReadModel>(
      {url: `/admin/videoNotices/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminvideoNoticesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/videoNotices/${id}`
    ] as const;
    }

    
export const getApiAdminvideoNoticesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminvideoNoticesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>> = ({ signal }) => apiAdminvideoNoticesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminvideoNoticesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>>
export type ApiAdminvideoNoticesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminvideoNoticesIdGet<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminvideoNoticesIdGet<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminvideoNoticesIdGet<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a video notice by ID
 */

export function useApiAdminvideoNoticesIdGet<TData = Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminvideoNoticesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a video notice
 * @summary Delete a video notice
 */
export const apiAdminvideoNoticesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/videoNotices/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminvideoNoticesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminvideoNoticesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminvideoNoticesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminvideoNoticesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>>
    
    export type ApiAdminvideoNoticesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Delete a video notice
 */
export const useApiAdminvideoNoticesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminvideoNoticesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminvideoNoticesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a video notice's title, description, video link and/or category
 * @summary Update a video notice
 */
export const apiAdminvideoNoticesIdPatch = (
    id: string | undefined | null,
    videoNoticeVideoNoticeUpdateJsonMergePatchModel: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<VideoNoticeVideoNoticeReadModel>(
      {url: `/admin/videoNotices/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: videoNoticeVideoNoticeUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminvideoNoticesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminvideoNoticesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>, {id: string | undefined | null;data: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminvideoNoticesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminvideoNoticesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>>
    export type ApiAdminvideoNoticesIdPatchMutationBody = BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>
    export type ApiAdminvideoNoticesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update a video notice
 */
export const useApiAdminvideoNoticesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminvideoNoticesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<VideoNoticeVideoNoticeUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminvideoNoticesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of WaitingList resources.
 * @summary Retrieves the collection of WaitingList resources.
 */
export const apiAdminwaitingListsGetCollection = (
    params?: ApiAdminwaitingListsGetCollectionParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApiAdminwaitingListsGetCollection200>(
      {url: `/admin/waiting_lists`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getApiAdminwaitingListsGetCollectionQueryKey = (params?: ApiAdminwaitingListsGetCollectionParams,) => {
    return [
    `/admin/waiting_lists`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getApiAdminwaitingListsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(params?: ApiAdminwaitingListsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminwaitingListsGetCollectionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>> = ({ signal }) => apiAdminwaitingListsGetCollection(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminwaitingListsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>>
export type ApiAdminwaitingListsGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiAdminwaitingListsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params: undefined |  ApiAdminwaitingListsGetCollectionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwaitingListsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminwaitingListsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwaitingListsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminwaitingListsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of WaitingList resources.
 */

export function useApiAdminwaitingListsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
 params?: ApiAdminwaitingListsGetCollectionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminwaitingListsGetCollectionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new company in waiting list
 * @summary Create a new company in waiting list
 */
export const apiAdminwaitingListsPost = (
    waitingListWaitingListWriteModel: BodyType<WaitingListWaitingListWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WaitingListWaitingListReadModel>(
      {url: `/admin/waiting_lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: waitingListWaitingListWriteModel, signal
    },
      options);
    }
  


export const getApiAdminwaitingListsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsPost>>, TError,{data: BodyType<WaitingListWaitingListWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsPost>>, TError,{data: BodyType<WaitingListWaitingListWriteModel>}, TContext> => {

const mutationKey = ['apiAdminwaitingListsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwaitingListsPost>>, {data: BodyType<WaitingListWaitingListWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminwaitingListsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwaitingListsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwaitingListsPost>>>
    export type ApiAdminwaitingListsPostMutationBody = BodyType<WaitingListWaitingListWriteModel>
    export type ApiAdminwaitingListsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new company in waiting list
 */
export const useApiAdminwaitingListsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsPost>>, TError,{data: BodyType<WaitingListWaitingListWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwaitingListsPost>>,
        TError,
        {data: BodyType<WaitingListWaitingListWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwaitingListsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a WaitingList resource.
 * @summary Retrieves a WaitingList resource.
 */
export const apiAdminwaitingListsIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WaitingListWaitingListReadModel>(
      {url: `/admin/waiting_lists/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminwaitingListsIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/waiting_lists/${id}`
    ] as const;
    }

    
export const getApiAdminwaitingListsIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminwaitingListsIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>> = ({ signal }) => apiAdminwaitingListsIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminwaitingListsIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>>
export type ApiAdminwaitingListsIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiAdminwaitingListsIdGet<TData = Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwaitingListsIdGet<TData = Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwaitingListsIdGet<TData = Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a WaitingList resource.
 */

export function useApiAdminwaitingListsIdGet<TData = Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminwaitingListsIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates the WaitingList resource.
 * @summary Updates the WaitingList resource.
 */
export const apiAdminwaitingListsIdPatch = (
    id: string | undefined | null,
    waitingListWaitingListWriteJsonMergePatchModel: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WaitingListWaitingListReadModel>(
      {url: `/admin/waiting_lists/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: waitingListWaitingListWriteJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminwaitingListsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminwaitingListsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>, {id: string | undefined | null;data: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminwaitingListsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwaitingListsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>>
    export type ApiAdminwaitingListsIdPatchMutationBody = BodyType<WaitingListWaitingListWriteJsonMergePatchModel>
    export type ApiAdminwaitingListsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the WaitingList resource.
 */
export const useApiAdminwaitingListsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwaitingListsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<WaitingListWaitingListWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwaitingListsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Accept or reject a waiting list
 * @summary Accept or reject a waiting list
 */
export const submitWaitingList = (
    id: string | undefined | null,
    waitingListWaitingListSubmitJsonMergePatchModel: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WaitingListWaitingListReadModel>(
      {url: `/admin/waiting_lists/${encodeURIComponent(String(id))}/submit`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: waitingListWaitingListSubmitJsonMergePatchModel
    },
      options);
    }
  


export const getSubmitWaitingListMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWaitingList>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitWaitingList>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>}, TContext> => {

const mutationKey = ['submitWaitingList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitWaitingList>>, {id: string | undefined | null;data: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  submitWaitingList(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitWaitingListMutationResult = NonNullable<Awaited<ReturnType<typeof submitWaitingList>>>
    export type SubmitWaitingListMutationBody = BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>
    export type SubmitWaitingListMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Accept or reject a waiting list
 */
export const useSubmitWaitingList = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitWaitingList>>, TError,{id: string | undefined | null;data: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof submitWaitingList>>,
        TError,
        {id: string | undefined | null;data: BodyType<WaitingListWaitingListSubmitJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getSubmitWaitingListMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of Widget resources.
 * @summary Retrieves the collection of Widget resources.
 */
export const apiAdminwidgetsGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WidgetWidgetReadModel[]>(
      {url: `/admin/widgets`, method: 'GET', signal
    },
      options);
    }
  



export const getApiAdminwidgetsGetCollectionQueryKey = () => {
    return [
    `/admin/widgets`
    ] as const;
    }

    
export const getApiAdminwidgetsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiAdminwidgetsGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>> = ({ signal }) => apiAdminwidgetsGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiAdminwidgetsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>>
export type ApiAdminwidgetsGetCollectionQueryError = ErrorType<ErrorJsonldModel | ErrorModel>


export function useApiAdminwidgetsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwidgetsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiAdminwidgetsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Widget resources.
 */

export function useApiAdminwidgetsGetCollection<TData = Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError = ErrorType<ErrorJsonldModel | ErrorModel>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiAdminwidgetsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiAdminwidgetsGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new widget with definitions
 * @summary Create a new widget with definitions
 */
export const apiAdminwidgetsPost = (
    widgetWidgetWriteModel: BodyType<WidgetWidgetWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WidgetWidgetReadModel>(
      {url: `/admin/widgets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: widgetWidgetWriteModel, signal
    },
      options);
    }
  


export const getApiAdminwidgetsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetsPost>>, TError,{data: BodyType<WidgetWidgetWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetsPost>>, TError,{data: BodyType<WidgetWidgetWriteModel>}, TContext> => {

const mutationKey = ['apiAdminwidgetsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwidgetsPost>>, {data: BodyType<WidgetWidgetWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminwidgetsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwidgetsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetsPost>>>
    export type ApiAdminwidgetsPostMutationBody = BodyType<WidgetWidgetWriteModel>
    export type ApiAdminwidgetsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Create a new widget with definitions
 */
export const useApiAdminwidgetsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetsPost>>, TError,{data: BodyType<WidgetWidgetWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwidgetsPost>>,
        TError,
        {data: BodyType<WidgetWidgetWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwidgetsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates the WidgetItemConfiguration resource.
 * @summary Updates the WidgetItemConfiguration resource.
 */
export const apiAdminwidgetItemConfigurationsIdPatch = (
    id: string | undefined | null,
    widgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WidgetItemConfigurationWidgetConfigReadModel>(
      {url: `/admin/widget_item_configurations/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: widgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminwidgetItemConfigurationsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminwidgetItemConfigurationsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>, {id: string | undefined | null;data: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminwidgetItemConfigurationsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwidgetItemConfigurationsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>>
    export type ApiAdminwidgetItemConfigurationsIdPatchMutationBody = BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>
    export type ApiAdminwidgetItemConfigurationsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Updates the WidgetItemConfiguration resource.
 */
export const useApiAdminwidgetItemConfigurationsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwidgetItemConfigurationsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwidgetItemConfigurationsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Link a widget to a workspace
 * @summary Link a widget to a workspace
 */
export const apiAdminwidgetWorkspacesPost = (
    widgetWorkspaceWidgetWorkspaceWriteModel: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WidgetWorkspaceWidgetWorkspaceReadModel>(
      {url: `/admin/widget_workspaces`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: widgetWorkspaceWidgetWorkspaceWriteModel, signal
    },
      options);
    }
  


export const getApiAdminwidgetWorkspacesPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>, TError,{data: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>, TError,{data: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>}, TContext> => {

const mutationKey = ['apiAdminwidgetWorkspacesPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>, {data: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminwidgetWorkspacesPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwidgetWorkspacesPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>>
    export type ApiAdminwidgetWorkspacesPostMutationBody = BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>
    export type ApiAdminwidgetWorkspacesPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Link a widget to a workspace
 */
export const useApiAdminwidgetWorkspacesPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>, TError,{data: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwidgetWorkspacesPost>>,
        TError,
        {data: BodyType<WidgetWorkspaceWidgetWorkspaceWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwidgetWorkspacesPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes the WidgetWorkspace resource.
 * @summary Removes the WidgetWorkspace resource.
 */
export const apiAdminwidgetWorkspacesIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/widget_workspaces/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminwidgetWorkspacesIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminwidgetWorkspacesIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminwidgetWorkspacesIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwidgetWorkspacesIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>>
    
    export type ApiAdminwidgetWorkspacesIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Removes the WidgetWorkspace resource.
 */
export const useApiAdminwidgetWorkspacesIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminwidgetWorkspacesIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Provide `slideIndex` (1-3) and `patchConfigurations` to replace all configurations for that slide
 * @summary Update name, isActive, startAt/endAt, sortOrder, and/or all configs for one slide
 */
export const apiAdminwidgetWorkspacesIdPatch = (
    id: string | undefined | null,
    widgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WidgetWorkspaceWidgetWorkspaceReadModel>(
      {url: `/admin/widget_workspaces/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: widgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminwidgetWorkspacesIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminwidgetWorkspacesIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>, {id: string | undefined | null;data: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminwidgetWorkspacesIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminwidgetWorkspacesIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>>
    export type ApiAdminwidgetWorkspacesIdPatchMutationBody = BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>
    export type ApiAdminwidgetWorkspacesIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update name, isActive, startAt/endAt, sortOrder, and/or all configs for one slide
 */
export const useApiAdminwidgetWorkspacesIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminwidgetWorkspacesIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminwidgetWorkspacesIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves the collection of WidgetWorkspace resources.
 * @summary Retrieves the collection of WidgetWorkspace resources.
 */
export const apiWidgetWorkspacesGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WidgetWorkspaceWidgetWorkspaceReadModel[]>(
      {url: `/widget_workspaces`, method: 'GET', signal
    },
      options);
    }
  



export const getApiWidgetWorkspacesGetCollectionQueryKey = () => {
    return [
    `/widget_workspaces`
    ] as const;
    }

    
export const getApiWidgetWorkspacesGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiWidgetWorkspacesGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>> = ({ signal }) => apiWidgetWorkspacesGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiWidgetWorkspacesGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>>
export type ApiWidgetWorkspacesGetCollectionQueryError = ErrorType<N401Response | N403Response>


export function useApiWidgetWorkspacesGetCollection<TData = Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWidgetWorkspacesGetCollection<TData = Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWidgetWorkspacesGetCollection<TData = Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of WidgetWorkspace resources.
 */

export function useApiWidgetWorkspacesGetCollection<TData = Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError = ErrorType<N401Response | N403Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWidgetWorkspacesGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiWidgetWorkspacesGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a Workspace resource.
 * @summary Creates a Workspace resource.
 */
export const inviteWorkspace = (
    workspaceWorkspaceInviteModel: BodyType<WorkspaceWorkspaceInviteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceWorkspaceReadModel>(
      {url: `/admin/workspaces/invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceWorkspaceInviteModel, signal
    },
      options);
    }
  


export const getInviteWorkspaceMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteWorkspace>>, TError,{data: BodyType<WorkspaceWorkspaceInviteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof inviteWorkspace>>, TError,{data: BodyType<WorkspaceWorkspaceInviteModel>}, TContext> => {

const mutationKey = ['inviteWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof inviteWorkspace>>, {data: BodyType<WorkspaceWorkspaceInviteModel>}> = (props) => {
          const {data} = props ?? {};

          return  inviteWorkspace(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type InviteWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof inviteWorkspace>>>
    export type InviteWorkspaceMutationBody = BodyType<WorkspaceWorkspaceInviteModel>
    export type InviteWorkspaceMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Creates a Workspace resource.
 */
export const useInviteWorkspace = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof inviteWorkspace>>, TError,{data: BodyType<WorkspaceWorkspaceInviteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof inviteWorkspace>>,
        TError,
        {data: BodyType<WorkspaceWorkspaceInviteModel>},
        TContext
      > => {

      const mutationOptions = getInviteWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns current logic workspace and the full logic collection for a given workspace
 * @summary Get workspace details (admin)
 */
export const getAdminWorkspace = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceWorkspaceReadAdminWorkspaceReadModel>(
      {url: `/admin/workspaces/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAdminWorkspaceQueryKey = (id?: string | undefined | null,) => {
    return [
    `/admin/workspaces/${id}`
    ] as const;
    }

    
export const getGetAdminWorkspaceQueryOptions = <TData = Awaited<ReturnType<typeof getAdminWorkspace>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminWorkspaceQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminWorkspace>>> = ({ signal }) => getAdminWorkspace(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAdminWorkspaceQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminWorkspace>>>
export type GetAdminWorkspaceQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useGetAdminWorkspace<TData = Awaited<ReturnType<typeof getAdminWorkspace>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getAdminWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminWorkspace<TData = Awaited<ReturnType<typeof getAdminWorkspace>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminWorkspace>>,
          TError,
          Awaited<ReturnType<typeof getAdminWorkspace>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAdminWorkspace<TData = Awaited<ReturnType<typeof getAdminWorkspace>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get workspace details (admin)
 */

export function useGetAdminWorkspace<TData = Awaited<ReturnType<typeof getAdminWorkspace>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminWorkspace>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAdminWorkspaceQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Replaces the Workspace resource.
 * @summary Replaces the Workspace resource.
 */
export const createWorkspace = (
    id: string | undefined | null,
    workspaceWorkspaceWriteModel: BodyType<WorkspaceWorkspaceWriteModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WorkspaceWorkspaceReadModel>(
      {url: `/admin/workspaces/${encodeURIComponent(String(id))}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: workspaceWorkspaceWriteModel
    },
      options);
    }
  


export const getCreateWorkspaceMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceWriteModel>}, TContext> => {

const mutationKey = ['createWorkspace'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createWorkspace>>, {id: string | undefined | null;data: BodyType<WorkspaceWorkspaceWriteModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  createWorkspace(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateWorkspaceMutationResult = NonNullable<Awaited<ReturnType<typeof createWorkspace>>>
    export type CreateWorkspaceMutationBody = BodyType<WorkspaceWorkspaceWriteModel>
    export type CreateWorkspaceMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Replaces the Workspace resource.
 */
export const useCreateWorkspace = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createWorkspace>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createWorkspace>>,
        TError,
        {id: string | undefined | null;data: BodyType<WorkspaceWorkspaceWriteModel>},
        TContext
      > => {

      const mutationOptions = getCreateWorkspaceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Live DNS configuration of the workspace domain and email configuration of its default sender
 * @summary Get the DNS and email configurations of a workspace
 */
export const getWorkspaceConfiguration = (
    id: number | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceConfigurationWorkspaceConfigurationReadModel>(
      {url: `/admin/workspaces/${encodeURIComponent(String(id))}/configuration`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWorkspaceConfigurationQueryKey = (id?: number | undefined | null,) => {
    return [
    `/admin/workspaces/${id}/configuration`
    ] as const;
    }

    
export const getGetWorkspaceConfigurationQueryOptions = <TData = Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError = ErrorType<N401Response | N403Response | N404Response | void>>(id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkspaceConfigurationQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceConfiguration>>> = ({ signal }) => getWorkspaceConfiguration(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkspaceConfigurationQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceConfiguration>>>
export type GetWorkspaceConfigurationQueryError = ErrorType<N401Response | N403Response | N404Response | void>


export function useGetWorkspaceConfiguration<TData = Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError = ErrorType<N401Response | N403Response | N404Response | void>>(
 id: number | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceConfiguration<TData = Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError = ErrorType<N401Response | N403Response | N404Response | void>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkspaceConfiguration>>,
          TError,
          Awaited<ReturnType<typeof getWorkspaceConfiguration>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkspaceConfiguration<TData = Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError = ErrorType<N401Response | N403Response | N404Response | void>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the DNS and email configurations of a workspace
 */

export function useGetWorkspaceConfiguration<TData = Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError = ErrorType<N401Response | N403Response | N404Response | void>>(
 id: number | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceConfiguration>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkspaceConfigurationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Active/Disable maintenance for current workspace
 * @summary Active/Disable maintenance for current workspace
 */
export const setMaintenance = (
    id: string | undefined | null,
    workspaceWorkspaceMaintenanceWriteJsonMergePatchModel: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WorkspaceWorkspaceReadModel>(
      {url: `/admin/workspaces/${encodeURIComponent(String(id))}/maintenance`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: workspaceWorkspaceMaintenanceWriteJsonMergePatchModel
    },
      options);
    }
  


export const getSetMaintenanceMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['setMaintenance'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setMaintenance>>, {id: string | undefined | null;data: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  setMaintenance(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetMaintenanceMutationResult = NonNullable<Awaited<ReturnType<typeof setMaintenance>>>
    export type SetMaintenanceMutationBody = BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>
    export type SetMaintenanceMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Active/Disable maintenance for current workspace
 */
export const useSetMaintenance = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setMaintenance>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setMaintenance>>,
        TError,
        {id: string | undefined | null;data: BodyType<WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getSetMaintenanceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Ask Vercel and Brevo to check the DNS records, then return the configurations like the GET endpoint
 * @summary Validate the DNS and email configurations of a workspace
 */
export const validateWorkspaceConfiguration = (
    id: number | undefined | null,
    validateWorkspaceConfigurationBody?: BodyType<ValidateWorkspaceConfigurationBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceConfigurationWorkspaceConfigurationReadModel>(
      {url: `/admin/workspaces/${encodeURIComponent(String(id))}/validate-configuration`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateWorkspaceConfigurationBody, signal
    },
      options);
    }
  


export const getValidateWorkspaceConfigurationMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateWorkspaceConfiguration>>, TError,{id: number | undefined | null;data: BodyType<ValidateWorkspaceConfigurationBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof validateWorkspaceConfiguration>>, TError,{id: number | undefined | null;data: BodyType<ValidateWorkspaceConfigurationBody>}, TContext> => {

const mutationKey = ['validateWorkspaceConfiguration'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof validateWorkspaceConfiguration>>, {id: number | undefined | null;data: BodyType<ValidateWorkspaceConfigurationBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  validateWorkspaceConfiguration(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ValidateWorkspaceConfigurationMutationResult = NonNullable<Awaited<ReturnType<typeof validateWorkspaceConfiguration>>>
    export type ValidateWorkspaceConfigurationMutationBody = BodyType<ValidateWorkspaceConfigurationBody>
    export type ValidateWorkspaceConfigurationMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel | void>

    /**
 * @summary Validate the DNS and email configurations of a workspace
 */
export const useValidateWorkspaceConfiguration = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof validateWorkspaceConfiguration>>, TError,{id: number | undefined | null;data: BodyType<ValidateWorkspaceConfigurationBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof validateWorkspaceConfiguration>>,
        TError,
        {id: number | undefined | null;data: BodyType<ValidateWorkspaceConfigurationBody>},
        TContext
      > => {

      const mutationOptions = getValidateWorkspaceConfigurationMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieves a Workspace resource.
 * @summary Retrieves a Workspace resource.
 */
export const apiWorkspacesIdGet = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceWorkspaceReadModel>(
      {url: `/workspaces/${encodeURIComponent(String(id))}`, method: 'GET', signal
    },
      options);
    }
  



export const getApiWorkspacesIdGetQueryKey = (id?: string | undefined | null,) => {
    return [
    `/workspaces/${id}`
    ] as const;
    }

    
export const getApiWorkspacesIdGetQueryOptions = <TData = Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiWorkspacesIdGetQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWorkspacesIdGet>>> = ({ signal }) => apiWorkspacesIdGet(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiWorkspacesIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof apiWorkspacesIdGet>>>
export type ApiWorkspacesIdGetQueryError = ErrorType<N401Response | N403Response | N404Response>


export function useApiWorkspacesIdGet<TData = Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWorkspacesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiWorkspacesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWorkspacesIdGet<TData = Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWorkspacesIdGet>>,
          TError,
          Awaited<ReturnType<typeof apiWorkspacesIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWorkspacesIdGet<TData = Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Workspace resource.
 */

export function useApiWorkspacesIdGet<TData = Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError = ErrorType<N401Response | N403Response | N404Response>>(
 id: string | undefined | null, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspacesIdGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiWorkspacesIdGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get workspace configs paginated
 * @summary Get workspace configs paginated
 */
export const adminWorkspaceConfigs = (
    params?: AdminWorkspaceConfigsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AdminWorkspaceConfigs200>(
      {url: `/admin/workspaceConfigs`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getAdminWorkspaceConfigsQueryKey = (params?: AdminWorkspaceConfigsParams,) => {
    return [
    `/admin/workspaceConfigs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getAdminWorkspaceConfigsQueryOptions = <TData = Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError = ErrorType<N401Response>>(params?: AdminWorkspaceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminWorkspaceConfigsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkspaceConfigs>>> = ({ signal }) => adminWorkspaceConfigs(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminWorkspaceConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof adminWorkspaceConfigs>>>
export type AdminWorkspaceConfigsQueryError = ErrorType<N401Response>


export function useAdminWorkspaceConfigs<TData = Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError = ErrorType<N401Response>>(
 params: undefined |  AdminWorkspaceConfigsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkspaceConfigs>>,
          TError,
          Awaited<ReturnType<typeof adminWorkspaceConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminWorkspaceConfigs<TData = Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError = ErrorType<N401Response>>(
 params?: AdminWorkspaceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkspaceConfigs>>,
          TError,
          Awaited<ReturnType<typeof adminWorkspaceConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminWorkspaceConfigs<TData = Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError = ErrorType<N401Response>>(
 params?: AdminWorkspaceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get workspace configs paginated
 */

export function useAdminWorkspaceConfigs<TData = Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError = ErrorType<N401Response>>(
 params?: AdminWorkspaceConfigsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkspaceConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminWorkspaceConfigsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add new workspace config
 * @summary Add new workspace config
 */
export const apiAdminworkspaceConfigsPost = (
    workspaceConfigWorkspaceConfigWriteModel: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WorkspaceConfigWorkspaceConfigReadModel>(
      {url: `/admin/workspaceConfigs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: workspaceConfigWorkspaceConfigWriteModel, signal
    },
      options);
    }
  


export const getApiAdminworkspaceConfigsPostMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>, TError,{data: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>, TError,{data: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>}, TContext> => {

const mutationKey = ['apiAdminworkspaceConfigsPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>, {data: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>}> = (props) => {
          const {data} = props ?? {};

          return  apiAdminworkspaceConfigsPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminworkspaceConfigsPostMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>>
    export type ApiAdminworkspaceConfigsPostMutationBody = BodyType<WorkspaceConfigWorkspaceConfigWriteModel>
    export type ApiAdminworkspaceConfigsPostMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Add new workspace config
 */
export const useApiAdminworkspaceConfigsPost = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>, TError,{data: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminworkspaceConfigsPost>>,
        TError,
        {data: BodyType<WorkspaceConfigWorkspaceConfigWriteModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminworkspaceConfigsPostMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete workspace config
 * @summary Delete workspace config
 */
export const apiAdminworkspaceConfigsIdDelete = (
    id: string | undefined | null,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/workspaceConfigs/${encodeURIComponent(String(id))}`, method: 'DELETE'
    },
      options);
    }
  


export const getApiAdminworkspaceConfigsIdDeleteMutationOptions = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>, TError,{id: string | undefined | null}, TContext> => {

const mutationKey = ['apiAdminworkspaceConfigsIdDelete'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>, {id: string | undefined | null}> = (props) => {
          const {id} = props ?? {};

          return  apiAdminworkspaceConfigsIdDelete(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminworkspaceConfigsIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>>
    
    export type ApiAdminworkspaceConfigsIdDeleteMutationError = ErrorType<N401Response | N403Response | N404Response>

    /**
 * @summary Delete workspace config
 */
export const useApiAdminworkspaceConfigsIdDelete = <TError = ErrorType<N401Response | N403Response | N404Response>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>, TError,{id: string | undefined | null}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdDelete>>,
        TError,
        {id: string | undefined | null},
        TContext
      > => {

      const mutationOptions = getApiAdminworkspaceConfigsIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update workspace config
 * @summary Update workspace config
 */
export const apiAdminworkspaceConfigsIdPatch = (
    id: string | undefined | null,
    workspaceConfigWorkspaceConfigUpdateJsonMergePatchModel: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WorkspaceConfigWorkspaceConfigReadModel>(
      {url: `/admin/workspaceConfigs/${encodeURIComponent(String(id))}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: workspaceConfigWorkspaceConfigUpdateJsonMergePatchModel
    },
      options);
    }
  


export const getApiAdminworkspaceConfigsIdPatchMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>}, TContext> => {

const mutationKey = ['apiAdminworkspaceConfigsIdPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>, {id: string | undefined | null;data: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>}> = (props) => {
          const {id,data} = props ?? {};

          return  apiAdminworkspaceConfigsIdPatch(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApiAdminworkspaceConfigsIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>>
    export type ApiAdminworkspaceConfigsIdPatchMutationBody = BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>
    export type ApiAdminworkspaceConfigsIdPatchMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @summary Update workspace config
 */
export const useApiAdminworkspaceConfigsIdPatch = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>, TError,{id: string | undefined | null;data: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof apiAdminworkspaceConfigsIdPatch>>,
        TError,
        {id: string | undefined | null;data: BodyType<WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getApiAdminworkspaceConfigsIdPatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Updates styles of a workspace
 * @deprecated
 * @summary Updates styles of a workspace
 */
export const customizer = (
    workspaceWorkspaceConfigWriteJsonMergePatchModel: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WorkspaceWorkspaceReadModel>(
      {url: `/customizer`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: workspaceWorkspaceConfigWriteJsonMergePatchModel
    },
      options);
    }
  


export const getCustomizerMutationOptions = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customizer>>, TError,{data: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customizer>>, TError,{data: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>}, TContext> => {

const mutationKey = ['customizer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customizer>>, {data: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>}> = (props) => {
          const {data} = props ?? {};

          return  customizer(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomizerMutationResult = NonNullable<Awaited<ReturnType<typeof customizer>>>
    export type CustomizerMutationBody = BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>
    export type CustomizerMutationError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>

    /**
 * @deprecated
 * @summary Updates styles of a workspace
 */
export const useCustomizer = <TError = ErrorType<ErrorJsonldModel | ErrorModel | N401Response | N403Response | N404Response | ConstraintViolationJsonldModel | ConstraintViolationModel>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customizer>>, TError,{data: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customizer>>,
        TError,
        {data: BodyType<WorkspaceWorkspaceConfigWriteJsonMergePatchModel>},
        TContext
      > => {

      const mutationOptions = getCustomizerMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get workspace configs
 * @summary Get workspace configs
 */
export const apiWorkspaceConfigsGetCollection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GroupedWorkspaceConfigModel>(
      {url: `/workspaceConfigs`, method: 'GET', signal
    },
      options);
    }
  



export const getApiWorkspaceConfigsGetCollectionQueryKey = () => {
    return [
    `/workspaceConfigs`
    ] as const;
    }

    
export const getApiWorkspaceConfigsGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError = ErrorType<N401Response>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiWorkspaceConfigsGetCollectionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>> = ({ signal }) => apiWorkspaceConfigsGetCollection(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ApiWorkspaceConfigsGetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>>
export type ApiWorkspaceConfigsGetCollectionQueryError = ErrorType<N401Response>


export function useApiWorkspaceConfigsGetCollection<TData = Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError = ErrorType<N401Response>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWorkspaceConfigsGetCollection<TData = Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError = ErrorType<N401Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>,
          TError,
          Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useApiWorkspaceConfigsGetCollection<TData = Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError = ErrorType<N401Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get workspace configs
 */

export function useApiWorkspaceConfigsGetCollection<TData = Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError = ErrorType<N401Response>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiWorkspaceConfigsGetCollection>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getApiWorkspaceConfigsGetCollectionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





